<template>
  <section id="main-box">

    <!-- 主要内容 -->
    <div class="col-box">
      <div class="col-main" style="background: none;padding: 0px;" v-if="datas">

        <!-- 遮罩层 -->
        <div class="MaskLayer" v-if="datas.categories.length <= 0"></div>

        <!-- 商品类目 -->
        <div class="nav-head" v-if="navlist.length > 1">
          <ul v-for="(item,index) in navlist">
            <li v-text="item.country+'-'+item.name" :class="{'nav-head-active':item.NavActive}" v-on:click="NavClick(index)"></li>
          </ul>
        </div>
        <div class="col-block offset-box">
          <div class="col-title">商品类目</div>
          <div class="col-data">
            <div class="col-row" id="shop-box" v-if="shop">
              <div class="col-left"><a><i class="required">*</i>店铺选择(shop)</a></div>
              <div class="col-right layui-form">
                <select type="text" lay-filter="shop_select" autocomplete="off" class="layui-select shop_box"
                  lay-search>
                  <option v-for="shop in shops" :data-shop="JSON.stringify(shop)" v-text="shop.country+'-'+shop.name"
                    :selected="shop.isSelect"></option>
                </select>
              </div>
            </div>

            <div class="col-row" v-if="shop">
              <div class="col-left"><a><i class="required">*</i>商品分类(classify)</a></div>
              <div class="col-right layui-form col-classify-box">
                <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="ShowClassify">选择分类</button>
                <a class="col-classify" v-if="datas.categories.length > 0">
                  <a v-for="(classify,index) in datas.categories">
                    <i v-if="classify.display_name_zh" v-text="classify.display_name_zh+'「'+classify.display_name+'」'"></i>
                    <i v-else v-text="classify.display_name"></i>
                    <i v-if="index != (datas.categories.length-1)" v-text="' > '"></i>
                  </a>
                  <a class="redColor" v-if="shop.country == 'TW' || shop.country == 'MX'">
                    <i v-if="datas.isSpecial == 0">（普货）</i>
                    <i v-if="datas.isSpecial == 1">（特货）</i>
                  </a>
                  <a class="col-classify-used-set" v-on:click="SetUsedClassify">设为常用</a>
                </a>
                <a v-else class="col-classify redtxt">
                  *请选择分类
                </a>
                <a class="col-classify-used" v-on:click="ShowUsedClassify"><i class="fa fa-book" ></i> 常用分类</a>
              </div>
            </div>
          </div>
          <div class="col-data">
            <div class="col-data-left" v-for="(attr,index) in attributes" :key="attr.attribute_id">
              <div class="col-row col-classify-row">
                <div class="col-left tipsBox" :class="'tips'+index" :data-ix="index">
                  <a>
                    <a>
                      <i class="col-left-data" v-if="attr.attribute_name_zh"><span class="required" v-if="attr.is_mandatory">*</span>{{attr.attribute_name_zh}}({{attr.attribute_name}})</i>
                      <i class="col-left-data" v-else><span class="required" v-if="attr.is_mandatory">*</span>{{attr.attribute_name}}</i>
                    </a>
                  </a>
                </div>

                <!-- 输入框 -->
                <div class="col-right layui-form" v-if="attr.input_type == 'TEXT_FILED'">
                  <input type="text" v-model="attr.current_select" class="input-box layui-input" placeholder="在此输入内容"
                    autocomplete="off">
                </div>

                <!-- 下拉框 -->
                <div class="col-right layui-form" v-if="attr.input_type == 'COMBO_BOX' || attr.input_type == 'DROP_DOWN'">
                  <!-- <input type="text" style="width: calc(100% - 40px);" class="search-input layui-input" v-on:input="inputFun"
                    :data-ix="index" v-model="attr.current_select" placeholder="可输入查询" autocomplete="off" :required="attr.is_mandatory"> -->
                  <select type="text" lay-filter="select_box" autocomplete="off" class="layui-select" lay-search>
                    <option v-if="!attr.current_select"></option>
                    <option v-for="(option,ix) in attr.options" v-text="attr.options_cn[ix]" :data-name="option"
                      :data-ix="index" :data-six="ix" :selected="option == attr.current_select_en"></option>
                  </select>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- 店铺&类目 -->

        <!-- 基本资讯 -->
        <div class="col-block offset-box">
          <div class="col-title">基本资讯</div>

          <div class="col-row" id="title-box" style="position: relative;">
            <div class="col-left"><a><i class="required">*</i>商品标题</a></div>
            <div class="col-right">
              <input :class="{'redborder':titleHint}" style="padding-right: 190px;width: calc(100% - 206px);" class="col-right-form"
                v-model="datas.name" v-on:input="TitleCheck(1)" placeholder="请输入标题" />
              <a class="UppercaseConversion" v-on:click="titleUpper">首字母大写</a>
              <a class="WordLimit">
                <i v-if="datas.name" v-text="datas.name.length"></i>
                <i v-else>0</i>
                /
                <i v-if="shop && shop.country == 'TW'">60</i>
                <i v-else>255</i>
              </a>
            </div>

            <!-- 标题提示 -->
            <div class="title-hint" v-if="titleHint">
              <i v-text="titleHintTxt"></i>
              <i class="layui-icon title-hint-icon"></i>
            </div>
          </div>

          <div class="col-row">
            <div class="col-left"><a><i class="required">*</i>商品货号</a></div>
            <div class="col-right">
              <input class="col-right-form" placeholder="自定义商品货号" v-model="datas.ProductCode" />
            </div>
          </div>
          <div class="col-row" style="position: relative;">
            <div class="col-left"><a><i class="required">*</i>商品描述</a></div>
            <div class="col-right">
              <textarea :class="{'redborder':desHint}" v-model="datas.description" v-on:input="TitleCheck(2)" class="col-right-form description-textarea"></textarea>
              <a class="WordLimit description-hint">
                <i v-if="datas.description" v-text="datas.description.length"></i>
                <i v-else>0</i>
                /
                <i v-if="shop && shop.country == 'TW'">3000</i>
                <i v-else>10000</i>
              </a>
            </div>

            <!-- 描述提示 -->
            <div class="title-hint" v-if="desHint">
              <i v-text="desHintTxt"></i>
              <i class="layui-icon title-hint-icon"></i>
            </div>
          </div>
        </div>
        <!-- 基本资讯 -->

        <!-- 图片&视频 -->
        <div class="col-block offset-box">
          <div class="col-title">图片&视频</div>
          <div class="images-box" id="images-box">

            <div class="images-head">
              <div class="images-head-left">
                图片数 <a v-text="datas.images.length+'/'+imglength" :class="{'hint-red':datas.images.length>imglength,'hint-green':datas.images.length<=imglength}"></a>
              </div>
              <div class="images-head-right layui-form">
                <a class="all-img" :class="{'all-img-active':allImg}" style="padding-right:0;">
                  <input type="checkbox" name="allimg" lay-filter="allimg" data-etype="pro" lay-skin="primary" title="全选" :checked="allImg">
                </a>
                <a class="all-img" v-on:click="OperateImg(1)">保留选中</a>
                <a class="all-img" v-on:click="OperateImg(2)">删除选中</a>
                <a class="all-img" v-on:click="ShowWaterPrint('pro')">添加水印</a>
                <a class="all-img" v-on:click="RestorePicture('pro')">恢复图片</a>
                <button class="layui-btn" type="button" lay-submit v-on:click="KeepPicture" v-if="datas.images && datas.images.length > imglength">保留前{{imglength}}张</button>
                <button class="layui-btn translation-img" v-on:mouseover="TriggerPulldown('pro')">
                  图片翻译
                  <i class="layui-icon layui-icon-down layui-font-12"></i>
                </button>
              </div>
            </div>

            <div class="col-row">
              <div class="col-left"><a>商品图片</a></div>
              <div class="col-right">
                <ul class="col-imglist">
                  <draggable element="ul" animation="300" filter=".col-select" v-model="datas.images" v-viewer>
                    <li v-for="(item,index) in datas.images" :class="{'img-active':item.isActive}">
                      <div class="col-img layui-form" :style="{'background-image': 'url('+item.url+')'}">
                        <img style="opacity: 0;" :src="item.url">
                        <a class="col-img-size" v-if="item.size" v-text="item.size"></a>
                        <a class="col-select-box NoSelect"><i class="col-select"><input clas="col-select-checkbox" type="checkbox"
                              name="imgSelect" lay-filter="imgSelect" data-etype="pro" :data-ix="index" lay-skin="primary" :checked="item.isActive"></i></a>
                        <p class="col-imglist-btn" v-if="item.url">
                          <a class="col-imglist-btn-a" v-on:click="beautifyImg('pro',index,item.url)"><i class="fa fa-pencil-square-o"></i>
                            美化</a>
                          <a class="col-imglist-btn-a" v-on:click="deletefile(index)"><i class="fa fa-trash-o"></i> 删除</a>
                        </p>
                      </div>
                      <p class="col-txt" v-if="index == 0">* 封面照片</p>
                      <p class="col-txt" v-else>图片 {{index+1}}</p>
                    </li>
                  </draggable>
                  <li>
                    <p class="col-img">
                      <a class="col-img-btn" v-on:click="PictureSelection('pro','产品图片')"><i class="layui-icon">&#xe624;</i>
                        产品图片</a>
                      <a class="col-img-btn" v-on:click="PictureSelection('pro','空间图片')"><i class="layui-icon">&#xe624;</i>
                        空间图片</a>
                      <a class="col-img-btn" v-on:click="WebPicture('pro')"><i class="layui-icon">&#xe624;</i> 网络图片</a>
                      <a class="col-img-btn">
                        <i class="layui-icon">&#xe624;</i> 本地上传
                        <input accept="image/*" class="addimginput upload_img" data-te="pro" multiple type="file" name="img">
                      </a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-row" v-if="datas.video_info_list && datas.video_info_list.length > 0">
            <div class="col-left"><a>商品视频</a></div>
            <div class="col-right">
              <ul class="col-imglist">
                <li v-for="(video,index) in datas.video_info_list">
                  <p class="col-img">
                    <video controls="controls" style="width: 100%">
                      <source :src="video.video_id" type="video/mp4" />
                    </video>
                  </p>
                  <p class="col-txt redtxt" style="width: 100%;">* 视频无法直接上传，如有需求请保存本地</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 图片&视频 -->

        <!-- 属性信息 -->
        <div class="col-block">
          <div class="col-title">属性信息</div>
          <div class="col-row" id="sku-box">
            <div class="col-left"><a><i class="required">*</i>商品类型</a></div>
            <div class="col-right layui-form">
              <div class="layui-input-inline">
                <input type="radio" name="sku" value="false" title="单SKU商品" lay-filter="sku" :checked="!datas.is_tier_variations">
                <input type="radio" name="sku" value="true" title="多SKU商品" lay-filter="sku" :checked="datas.is_tier_variations">
              </div>
            </div>
          </div>

          <!-- 单SKU -->
          <section v-if="!datas.is_tier_variations">

            <div class="col-row">
              <div class="col-left"><a>折扣促销</a></div>
              <div class="col-right layui-form">
                <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="promotion">选择</button>
                <a class="discount-txt" v-if="datas.discount_info && datas.discount_info.name">
                  <i v-text="datas.discount_info.name + '('+datas.discount_info.id+')'"></i>
                  <i class="fa fa-times discount_close" v-on:click="DeleteDiscount"></i>
                </a>
                <a class="discount-txt redtxt" v-else>(不选则没有折扣价)</a>
              </div>
            </div>
            <div class="col-row">
              <div class="col-left"><a><i v-if="datas.discount_info && datas.discount_info.name">*</i>折扣限量</a></div>
              <div class="col-right" style="width: 280px;">
                <input class="col-right-form" v-model="datas.limit" />
              </div>
            </div>

            <!-- 自动定价模板 -->
            <div class="col-data" id="weight-box" v-if="pricing.length > 0">
              <div class="col-data-left" style="width: calc(50% - 105px);">
                <div class="col-row">
                  <div class="col-left"><a><i class="required">*</i>定价模板</a></div>
                  <div class="col-right layui-form">
                    <select type="text" lay-filter="pricing_select" autocomplete="off" class="layui-select">
                      <option v-for="(pobj,index) in pricing" :data-id="pobj.id" v-text="pobj.name" :data-ix="index"
                        :selected="pobj.is_select == 1"></option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-data-left" style="width: calc(50% - 105px);">
                <div class="col-row" style="padding-left: 0;">
                  <div class="col-left"><a><i class="required">*</i>包裹重量</a></div>
                  <div class="col-right">
                    <input class="col-right-form" v-model="datas.weight" placeholder="输入重量" v-on:keydown.13="CountPrice"
                      v-on:change="InputDetection('weight',1)" />
                    <a class="col-right-unit">g</a>
                  </div>
                </div>
              </div>
              <div class="col-data-left" style="width: 210px;">
                <div class="col-row" style="padding-left: 0;">
                  <button class="layui-btn" style="margin-right: 5px;" type="button" lay-submit v-on:click="CountPrice">自动定价</button>
                  <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="RecoverPrice">恢复价格</button>
                </div>
              </div>
            </div>
            <div class="col-data" id="weight-box" v-else>
              <div class="col-data-left" style="width: calc(39% - 70px);">
                <div class="col-row">
                  <div class="col-left"><a><i class="required">*</i>定价模板</a></div>
                  <div class="col-right layui-form">
                    <select type="text" lay-filter="pricing_select" autocomplete="off" class="layui-select">
                      <option v-for="(pobj,index) in pricing" :data-id="pobj.id" v-text="pobj.name" :data-ix="index"
                        :selected="pobj.is_select == 1"></option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-data-left" style="width: 70px;">
                <div class="Refreshpricing" v-on:click="get_pricing"><i class="fa fa-refresh"></i> 刷新</div>
              </div>
              <div class="col-data-left" style="width: 39%;">
                <div class="col-row" style="padding-left: 0;">
                  <div class="col-left"><a><i class="required">*</i>包裹重量</a></div>
                  <div class="col-right">
                    <input class="col-right-form" v-model="datas.weight" placeholder="输入重量" v-on:change="InputDetection('weight',1)" />
                    <a class="col-right-unit">g</a>
                  </div>
                </div>
              </div>
              <div class="col-data-left" style="width: 10%;">
                <div class="col-row" style="padding-left: 0;">
                  <button class="layui-btn" type="button" lay-submit v-on:click="OpenPage('Pricing')">添加自动定价模板</button>
                </div>
              </div>
            </div>
            <!-- 自动定价模板 -->

            <div class="col-row">
              <div class="col-left"><a><i class="required">*</i>销售价</a></div>
              <div class="col-right">
                <input class="col-right-form" v-model="datas.price_before_discount" v-on:change="InputDetection('price_before_discount',1,false)" />
              </div>
            </div>
            <div class="col-row">
              <div class="col-left"><a>促销价</a></div>
              <div class="col-right">
                <input class="col-right-form" v-model="datas.price" v-on:change="InputDetection('price',1,false)" />
              </div>
            </div>
            <div class="col-row">
              <div class="col-left"><a><i class="required">*</i>库存</a></div>
              <div class="col-right">
                <input class="col-right-form" v-model="datas.stock" v-on:change="InputDetection('stock',1)" />
              </div>
            </div>
            <div class="col-row">
              <div class="col-left"><a>折扣</a></div>
              <div class="col-right">
                <input class="col-right-form" v-model="datas.diskaun" v-on:change="InputDetection('diskaun',1,true)" />
              </div>
            </div>
          </section>
          <!-- 单SKU -->

          <!-- 多SKU -->
          <section v-else>
            <div class="offset-box">
              <div class="col-data" v-for="(model,index) in datas.tier_variations">
                <div class="col-data-left" style="width: 30%;">
                  <div class="col-row">
                    <div class="col-left"><a><i class="required">*</i>SKU属性</a></div>
                    <div class="col-right layui-form">
                      <input v-model="model.name" class="col-right-form" />
                      <i class="fa fa-trash-o col-right-icon" v-on:click="deleteSku(1,index)"></i>
                    </div>
                  </div>
                </div>
                <div class="col-data-right" style="width: 68%;">
                  <div class="col-row">
                    <ul class="col-sku-box">
                      <li class="col-sku-head">
                        <a>属性值(不能超过30个字符)</a>
                        <a class="auto-sku layui-btn layui-btn-primary" v-on:click="AutoSku(index)">自动生成</a>
                        <a class="auto-sku layui-btn layui-btn-primary" v-on:click="Reduction(index)">还原SKU</a>
                        <a class="auto-sku layui-btn layui-btn-primary" v-on:click="UnitConversion(index)">斤转kg</a>
                        <a v-text="model.options.length"></a>
                      </li>
                      <li class="col-sku-main">
                        <div class="col-sku-data">
                          <div class="col-sku-top NoSelect">
                            <draggable element="ul" animation="300" v-model="model.options" @end="onEnd" :data-ix="index">
                              <div class="col-sku-block" v-for="(option,ix) in model.options"  :class="{'redborder':option.length > 30}">
                                <i>{{option}}</i>
                                <span>
                                  <i v-text="option.length"></i>
                                  <i class="fa fa-edit" v-on:click="EditSku(index,ix,option)"></i>
                                  <i v-on:click="deleteSku(2,index,ix)" class="fa fa-remove"></i>
                                </span>
                              </div>
                            </draggable>
                          </div>
                          <div class="col-sku-bottom">
                            <input class="col-sku-input" :data-ix="index" placeholder="在此输入SKU回车添加, SKU可拖动排序, SKU总数不能超过50个" />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="add-skut" v-on:click="AddSku" v-if="datas.tier_variations.length < 2"><i class="fa fa-plus"></i>添加属性</div>

              <div class="images-box" id="sku-imgs">
                <div class="images-head">
                  <div class="images-head-right layui-form">
                    <a class="all-img" :class="{'all-img-active':allSkuImg}" style="padding-right:0;">
                      <input type="checkbox" name="allimg" lay-filter="allimg" data-etype="sku" lay-skin="primary" title="全选" :checked="allSkuImg">
                    </a>
                    <a class="all-img" v-on:click="OperateImg(1,'sku')">保留选中</a>
                    <a class="all-img" v-on:click="OperateImg(2,'sku')">删除选中</a>
                    <a class="all-img" v-on:click="ShowWaterPrint('sku')">添加水印</a>
                    <a class="all-img" v-on:click="RestorePicture('sku')">恢复图片</a>
                    <button class="layui-btn translation-img" v-on:mouseover="TriggerPulldown('sku')">
                      图片翻译
                      <i class="layui-icon layui-icon-down layui-font-12"></i>
                    </button>
                  </div>
                </div>
                <div v-for="model in datas.tier_variations">
                  <div class="col-row" v-if="model.images.length > 0">
                    <div class="col-left"><a v-text="model.name"></a></div>
                    <div class="col-right">
                      <ul class="col-imglist" v-viewer>
                        <draggable element="ul" animation="300" v-model="model.images">
                          <li v-for="(img,index) in model.images" :class="{'img-active':img.isActive}">
                            <div v-if="img.url" class="col-img layui-form" :style="{'background-image': 'url('+img.url+')'}">
                              <img :src="img.url" style="opacity:0;">
                              <a class="col-img-size" v-if="img.size" v-text="img.size"></a>
                              <a class="col-select-box NoSelect"><i class="col-select"><input clas="col-select-checkbox" type="checkbox"
                                    name="imgSelect" lay-filter="imgSelect" data-etype="sku" :data-ix="index" lay-skin="primary" :checked="img.isActive"></i></a>
                              <p class="col-imglist-btn" v-if="img.url">
                                <a class="col-imglist-btn-a" v-on:click="beautifyImg('sku',index,img.url)"><i class="fa fa-pencil-square-o"></i>
                                  美化</a>
                                <a class="col-imglist-btn-a" v-on:click="deletefile(index,2)"><i class="fa fa-trash-o"></i>
                                  删除</a>
                              </p>
                            </div>
                            <p v-else class="col-img">
                              <a class="col-img-btn" v-on:click="PictureSelection('sku','产品图片',index)"><i class="layui-icon">&#xe624;</i>
                                产品图片</a>
                              <a class="col-img-btn" v-on:click="PictureSelection('sku','空间图片',index)"><i class="layui-icon">&#xe624;</i>
                                空间图片</a>
                              <a class="col-img-btn" v-on:click="WebPicture('sku',index)"><i class="layui-icon">&#xe624;</i>
                                网络图片</a>
                              <a class="col-img-btn">
                                <i class="layui-icon">&#xe624;</i> 本地上传
                                <input accept="image/*" class="addimginput upload_img" data-te="sku" :data-ix="index" type="file"
                                  name="img">
                              </a>
                            </p>
                            <p style="width: 135px;" class="col-txt onlyOneRow" v-text="model.options[index]"></p>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-data">
                <div class="col-data-left" style="width: calc(50% - 106px);">
                  <div class="col-row">
                    <div class="col-left"><a><i class="required" v-if="datas.discount_info && datas.discount_info.name">*</i>折扣限量</a></div>
                    <div class="col-right">
                      <input class="col-right-form" v-model="datas.limit" />
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: calc(50% + 106px);">
                  <div class="col-row" style="padding-left: 0;">
                    <div class="col-left"><a>折扣促销</a></div>
                    <div class="col-right layui-form">
                      <button class="layui-btn layui-btn-primary" type="button" v-on:click="promotion" lay-submit>选择</button>
                      <a class="discount-txt" v-if="datas.discount_info && datas.discount_info.name">
                        <i v-text="datas.discount_info.name + '('+datas.discount_info.id+')'"></i>
                        <i class="fa fa-times discount_close" v-on:click="DeleteDiscount"></i>
                      </a>
                      <a class="discount-txt redtxt" v-else>(不选则没有折扣价)</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-data"></div>

              <div class="col-data" id="weight-box" v-if="pricing.length > 0">

                <div class="col-data-left" style="width: calc(50% - 105px);">
                  <div class="col-row" key="pricing">
                    <div class="col-left"><a><i class="required">*</i>定价模板</a></div>
                    <div class="col-right layui-form">
                      <select type="text" lay-filter="pricing_select" autocomplete="off" class="layui-select">
                        <option v-for="(pobj,index) in pricing" :data-id="pobj.id" v-text="pobj.name" :data-ix="index"
                          :selected="pobj.is_select == 1"></option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: calc(50% - 105px);">
                  <div class="col-row" style="padding-left: 0;">
                    <div class="col-left"><a><i class="required">*</i>包裹重量</a></div>
                    <div class="col-right">
                      <input class="col-right-form" v-model="datas.weight" placeholder="输入重量" v-on:keydown.13="CountPrice"
                        v-on:change="InputDetection('weight',1)" />
                      <a class="col-right-unit">g</a>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: 210px;">
                  <div class="col-row" style="padding-left: 0;">
                    <button class="layui-btn" style="margin-right: 5px;" type="button" lay-submit v-on:click="CountPrice">自动定价</button>
                    <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="RecoverPrice">恢复价格</button>
                  </div>
                </div>
              </div>
              <div class="col-data" id="weight-box" v-else>
                <div class="col-data-left" style="width: calc(39% - 70px);">
                  <div class="col-row" key="pricing">
                    <div class="col-left"><a><i class="required">*</i>定价模板</a></div>
                    <div class="col-right layui-form">
                      <select type="text" lay-filter="pricing_select" autocomplete="off" class="layui-select">
                        <option v-for="(pobj,index) in pricing" :data-id="pobj.id" v-text="pobj.name" :data-ix="index"
                          :selected="pobj.is_select == 1"></option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" id="weight-box" style="width: 70px;">
                  <div class="Refreshpricing" v-on:click="get_pricing"><i class="fa fa-refresh"></i> 刷新</div>
                </div>
                <div class="col-data-left" style="width: 39%;">
                  <div class="col-row" style="padding-left: 0;">
                    <div class="col-left"><a><i class="required">*</i>包裹重量</a></div>
                    <div class="col-right">
                      <input class="col-right-form" v-model="datas.weight" placeholder="输入重量" v-on:keydown.13="CountPrice"
                        v-on:change="InputDetection('weight',1)" />
                      <a class="col-right-unit">g</a>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: 10%;">
                  <div class="col-row" style="padding-left: 0;">
                    <button class="layui-btn" type="button" lay-submit v-on:click="OpenPage('Pricing')">添加自动定价模板</button>
                  </div>
                </div>
              </div>
              <div class="edit-hint">提示：点击自动定价按钮，系统会拉取采集的商品价格 根据定价模板自动计算出商品销售价、促销价</div>

            </div>
            <div class="col-row" id="sku-table">
              <div class="col-left"><a>規格表</a></div>
              <div class="col-right">
                <table class="layui-table layui-form">
                  <thead>
                    <tr>
                      <th v-for="sku in datas.tier_variations">
                        <i v-if="sku.name" v-text="sku.name"></i>
                        <i v-else>規格名稱</i>
                      </th>
                      <th class="BulkEditTips Tips1" data-pix="1" data-te="name">SKU编号 <i class="fa fa-file-text-o"></i></th>
                      <th class="BulkEditTips Tips2" data-pix="2" data-te="price_before_discount">销售价 <i class="fa fa-file-text-o"></i></th>
                      <th class="BulkEditTips Tips3" data-pix="3" data-te="price">促销价 <i class="fa fa-file-text-o"></i></th>
                      <th class="BulkEditTips Tips4" data-pix="4" data-te="diskaun">折扣 <i class="fa fa-file-text-o"></i></th>
                      <th class="BulkEditTips Tips5" data-pix="5" data-te="weight">重量 <i class="fa fa-file-text-o"></i></th>
                      <th class="BulkEditTips Tips6" data-pix="6" data-te="stock">库存 <i class="fa fa-file-text-o"></i></th>
                    </tr>
                  </thead>
                  <tr v-for="(val,ix) in datas.customize_tier_variations">
                    <td v-if="datas.tier_variations.length > 0">
                      <i v-if="val.list[0]" v-text="val.list[0]"></i>
                      <i v-else></i>
                    </td>
                    <td v-if="datas.tier_variations.length > 1">
                      <i v-if="val.list[1]" v-text="val.list[1]"></i>
                      <i v-else></i>
                    </td>
                    <td><input class="table-input" v-model="val.name"></td>
                    <td><input class="table-input" :class="{'redborder':!val.price_before_discount || val.price_before_discount == 0}"
                        v-model="val.price_before_discount" v-on:change="InputDetection('price_before_discount',2,false,ix)"></td>
                    <td><input class="table-input" :class="{'redborder':!val.price || val.price == 0}" v-model="val.price"
                        v-on:change="InputDetection('price',2,false,ix)"></td>
                    <td><input class="table-input" v-model="val.diskaun" v-on:change="InputDetection('diskaun',2,true,ix)"></td>
                    <td><input class="table-input" v-model="val.weight" v-on:change="InputDetection('weight',2,false,ix)"></td>
                    <td><input class="table-input" v-model="val.stock" v-on:change="InputDetection('stock',2,false,ix)"></td>
                  </tr>
                </table>
              </div>
            </div>

          </section>
          <!-- 多SKU -->

        </div>
        <!-- 属性信息 -->


        <!-- 物流信息 -->
        <div class="col-block">
          <div class="col-title">物流信息</div>
          <div class="col-row" id="log-box">
            <div class="col-left"><a><i class="required">*</i>是否预售</a></div>
            <div class="col-right layui-form">
              <div class="layui-input-inline" id="Pre-sale">
                <input type="radio" name="Pre-sale" value="false" title="否" lay-filter="Pre-sale" :checked="!datas.is_pre_sale">
                <input type="radio" name="Pre-sale" value="true" title="是" lay-filter="Pre-sale" :checked="datas.is_pre_sale">
              </div>
            </div>
            <div class="col-right">
              <div class="col-log-hint" style="line-height: 27px;" v-if="!datas.is_pre_sale">我将在3天内发货（不包括公共假期和物流服务休息日）。</div>
              <div class="col-log-hint" v-else>
                <a>我需要</a>
                <a><input max="10" min="5" type="txt" v-on:change="SaleDay" v-model="datas.pre_sale" /></a>
                <a>出货天数（您可以填写5至10）</a>
              </div>
            </div>
          </div>
          <div class="col-row">
            <div class="col-left"><a><i class="required">*</i>包裹尺寸</a></div>
            <div class="col-right">
              <div class="col-right-inputs col-right-three"><input class="col-right-form" v-model="datas.baglength"
                  placeholder="长" v-on:change="InputDetection('baglength',1,false)" /><a class="col-right-unit">cm</a></div>
              <div class="col-right-inputs col-right-three"><input class="col-right-form" v-model="datas.bagwidth"
                  placeholder="宽" v-on:change="InputDetection('bagwidth',1,false)" /><a class="col-right-unit">cm</a></div>
              <div class="col-right-inputs col-right-three"><input class="col-right-form" v-model="datas.bagheight"
                  placeholder="高" v-on:change="InputDetection('bagheight',1,false)" /><a class="col-right-unit">cm</a></div>
            </div>
          </div>
          <div class="col-row">
            <div class="col-left"><a><i class="required">*</i>物流方式</a></div>
            <div class="col-right layui-form">
              <div class="col-right-checkbox"><input type="checkbox" name="logall" lay-filter="logall" lay-skin="primary"
                  title="全选" checked></div>
              <div class="col-right-checkbox" v-for="(log,index) in datas.logistics">
                <input class="log-box" type="checkbox" lay-filter="log" :data-ix="index" lay-skin="primary" :title="log.logistic_name"
                  :checked="log.enabled">
                <div class="layui-form-item col-right-switch">
                  <label class="layui-form-label">是否免运：</label>
                  <div class="layui-input-block">
                    <input type="checkbox" name="close" lay-skin="switch" lay-filter="FreeShip" :data-ix="index"
                      lay-text="是|否" :checked="log.isFree">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 物流信息 -->

        <!-- 发布设置 -->
        <div class="col-block">
          <div class="col-title">发布设置</div>
          <div class="col-row" id="timing-box">
            <div class="col-left"><a>发布时间</a></div>
            <div class="col-right layui-form">
              <div class="layui-input-inline">
                <input type="radio" name="publish_now" value="true" title="立即发布" lay-filter="publish_now" :checked="datas.publish_now">
                <input type="radio" name="publish_now" value="false" title="定时发布" lay-filter="publish_now" :checked="!datas.publish_now">
              </div>
            </div>
          </div>
          <div class="col-row" v-if="!datas.publish_now">
            <div class="col-left"><a><i class="required">*</i>时间设置</a></div>
            <div class="col-right">
              <div class="col-right-inputs col-right-three">
                <input type="text" lay-verify="required" class="layui-input" id="publish_date" v-model="datas.publish_date"
                  placeholder="发布开始时间" autocomplete="off">
              </div>
              <div class="col-right-inputs col-right-three">
                <input class="layui-input" placeholder="发布频率" id="publish_rate" v-model="datas.publish_rate"
                  v-on:change="InputDetection('publish_rate',1)" />
                <a class="col-right-unit">分钟</a>
              </div>
            </div>
          </div>
          <div class="col-row">
            <div class="col-left"><a>上架设置</a></div>
            <div class="col-right layui-form">
              <div class="layui-input-inline">
                <input type="radio" name="is_listed" value="true" title="立即上架" lay-filter="is_listed" :checked="datas.is_listed">
                <input type="radio" name="is_listed" value="false" title="暂不上架" lay-filter="is_listed" :checked="!datas.is_listed">
              </div>
            </div>
          </div>
          <div class="col-row">
            <div class="col-left"><a>SKU原价</a></div>
            <div class="col-right layui-form">
              <div class="layui-input-inline">
                <input type="radio" name="skuprice" value="true" title="是" lay-filter="skuprice" :checked="datas.skuprice">
                <input type="radio" name="skuprice" value="false" title="否" lay-filter="skuprice" :checked="!datas.skuprice">
                <i class="layui-form-hint">（是否自动将商品原价添加至SKU规格中）</i>
              </div>
            </div>
          </div>
        </div>
        <!-- 发布设置 -->

      </div>

      <!-- transition -->
      <K-Transition :isLoding="isLoding" style="width: 1160px;margin:15px auto;" v-else></K-Transition>

    </div>
    <!-- 主要内容 -->

    <!-- 底部菜单 -->
    <div class="col-footer" v-if="datas">
      <div class="col-footer-box">
        <div class="col-footer-left">
          <button v-if="shop" class="layui-btn layui-btn-normal" type="button" lay-submit v-on:click="translation">一键翻译</button>
          <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="Source">商品来源</button>
        </div>
        <div class="col-footer-right">
          <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="ClosePage">关闭</button>
          <button class="layui-btn layui-btn-warm" type="button" lay-filter="save" data-etype="true" lay-submit>另存为</button>
          <button v-if="shop" class="layui-btn layui-btn-danger" type="button" lay-filter="save" data-etype="false" lay-submit>保存</button>
          <button v-if="shop" class="layui-btn" type="button" lay-filter="release" lay-submit>发布</button>
        </div>
      </div>
    </div>
    <!-- 底部菜单 -->

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </section>
</template>

<script>
  var self, form, layer, slider, laypage, laydate, dropdown, skuinfo, xmlModule, xmlTwoModule, xmlThreeModule, sliderVal = 1,
    isSlider, WatermarkList, picix, titleTips, allType, editType, editor;
  import axios from 'axios'
  import draggable from 'vuedraggable'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  import * as gaoding from '@gaoding/editor-sdk';
  export default {
    name: 'Promote',
    components: {
      draggable,
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        SpacePage:1,
        uid: null,
        isLoding: true,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        te: null,
        itemid: null,
        imgs: 1,
        imglength:9,
        datas: null,
        navlist: [],
        shop: null,
        shops: [],
        current_shop: null,
        attributes: null,
        discounts: null,
        categories: [],
        CurrentClassify: null,
        pricing: [],
        boxheight: 0,
        allImg: false,
        allSkuImg: false,
        isClick: false,
        TranslationList: this.LanguageList(),
        WatermarkID: null,
        etype: null,
        Spaceimgs: [],
        titleHint: false,
        titleHintTxt: null,
        desHint: false,
        desHintTxt: null,
        UsedClassify:[]
      }
    },
    updated() {
      if (self.datas) {
        var boxheight = $(".col-main").height() - 174;
        self.boxheight = boxheight;
      }

      if (form) {
        form.render();
      }
    },
    mounted: function() {
      self = this;
      self.uid = localStorage.getItem("ExShopee_id");
      if (self.$route.query.id) {
        self.itemid = self.$route.query.id;
      }

      if (localStorage.getItem("ExShopee_EditType")) {
        self.te = localStorage.getItem("ExShopee_EditType");
      }

      //图片美化
      editor = gaoding.createImageEditor({
        appId: 'HCEZVL492117',
      });

      layui.use(['form', 'layer', 'slider', 'laypage', 'laydate', 'dropdown'], function() {
        form = layui.form;
        layer = layui.layer;
        slider = layui.slider;
        laypage = layui.laypage;
        laydate = layui.laydate;
        dropdown = layui.dropdown;

        //促销活动全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
          });

          //设置SKU选择状态
          for (let i in self.datas.customize_tier_variations) {
            self.datas.customize_tier_variations[i].istrue = data.elem.checked;
            self.datas.models[i].istrue = data.elem.checked;
          }
          form.render('checkbox');
        });

        //图片全选
        form.on('checkbox(allimg)', function(data) {
          let etype = data.elem.dataset.etype;
          let status = data.elem.checked;
          if(etype == "pro"){
            self.allImg = status;
            for (let i in self.datas.images) {
              self.datas.images[i].isActive = status;
            }
          }else{
            self.allSkuImg = status;
            if(self.datas.tier_variations && self.datas.tier_variations.length > 0){
              for(let i in self.datas.tier_variations[0].images){
                self.datas.tier_variations[0].images[i].isActive = status;
              }
            }
          }
          form.render('checkbox');
        });

        //图片选中
        form.on('checkbox(imgSelect)', function(data) {
          let ix = data.elem.dataset.ix;
          let etype = data.elem.dataset.etype;
          let status = data.elem.checked;

          if(etype == 'pro'){
            self.datas.images[ix].isActive = status;
          }else{
            self.datas.tier_variations[0].images[ix].isActive = status;
          }

          form.render('checkbox');
        });

        //SKU选中
        form.on('checkbox(SelectedSku)', function(data) {
          let status = data.elem.checked;
          let ix = data.elem.dataset.ix;
          if (self.datas.customize_tier_variations[ix].istrue) {
            self.datas.customize_tier_variations[ix].istrue = false;
            self.datas.models[ix].istrue = false;
          } else {
            self.datas.customize_tier_variations[ix].istrue = true;
            self.datas.models[ix].istrue = true;
          }
          layui.stope(); //阻止冒泡
        });

        //SKU选中
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.datas.customize_tier_variations[ix].istrue) {
            self.datas.customize_tier_variations[ix].istrue = false;
            self.datas.models[ix].istrue = false;
          } else {
            self.datas.customize_tier_variations[ix].istrue = true;
            self.datas.models[ix].istrue = true;
          }
          console.log("触发")
          form.render('checkbox');
          self.$forceUpdate();
        });

        //物流选择
        form.on('checkbox(log)', function(data) {
          let ix = data.elem.dataset.ix;
          console.log(ix)
          self.datas.logistics[ix].enabled = data.elem.checked;
        });
        form.on('checkbox(logall)', function(data) {
          var child = $(".log-box");
          child.each(function(index, item) {
            item.checked = data.elem.checked;
          });
          for (let i in self.datas.logistics) {
            self.datas.logistics[i].enabled = data.elem.checked;
          }
          form.render('checkbox');
        });
        //是否免运
        form.on('switch(FreeShip)', function(data) {
          let ix = data.elem.dataset.ix;
          self.datas.logistics[ix].isFree = data.elem.checked;
        });

        //店铺选择-下拉
        form.on('select(shop_select)', function(data) {
          let status = data.elem.checked;
          let ix = data.elem.dataset.ix

          var shop = JSON.parse(data.elem[data.elem.selectedIndex].dataset.shop);
          self.shop = shop;
          self.datas.isSpecial = null; //商品类型特货、普货
          self.datas.categories = [];
          self.categories = [];
          self.attributes = [];

          //西班牙图片
          if(self.shop.country == "ES"){
            self.imglength = 20;
          }

          for (let item in self.datas.models) {
            self.datas.models[item].weight = self.datas.customize_tier_variations[item].weight;
          }

          self.datas.customize_tier_variations = JSON.parse(JSON.stringify(self.datas.models))
          self.datas.logistics = [];
          self.datas.discount_info = null;
          self.discounts = [];
          self.get_categories(true); //加载分类
          self.get_logistics(); //重新获取快递
          self.get_discounts_list(); //重新获取折扣
          self.TitleCheck(1); //标题检测
          self.TitleCheck(2); //描述检测
          self.$forceUpdate();
        });

        //状态选择
        form.on('select(select_box)', function(data) {
          var txt = data.elem[data.elem.selectedIndex].text;
          var ix = data.elem[data.elem.selectedIndex].dataset.ix;
          var name = data.elem[data.elem.selectedIndex].dataset.name;
          console.log(name)
          self.attributes[ix].current_select = txt;
          self.attributes[ix].current_select_en = name;
          self.$forceUpdate();
        });

        //定价模板选择
        form.on('select(pricing_select)', function(data) {
          var ix = data.elem[data.elem.selectedIndex].dataset.ix;
          for (let item in self.pricing) {
            self.pricing[item].is_select = 0;
          }
          self.pricing[ix].is_select = 1;
          console.log(self.pricing)
        });

        //Sku类型切换
        form.on('radio(sku)', function(data) {
          self.datas.is_tier_variations = JSON.parse(data.value);
        });

        //预售选择
        form.on('radio(Pre-sale)', function(data) {
          if (JSON.parse(data.value)) {
            self.datas.pre_sale = 5;
          } else {
            self.datas.pre_sale = 3;
          }
          self.datas.pre_sale = 5;
          self.datas.is_pre_sale = JSON.parse(data.value);
        });

        //发布类型
        form.on('radio(publish_now)', function(data) {
          self.datas.publish_now = JSON.parse(data.value);
          if (!JSON.parse(data.value)) {
            self.$nextTick(() => {
              laydate.render({
                elem: '#publish_date',
                type: 'datetime',
                min: 0,
                max: 15,
                trigger: 'click',
                done: function(value, date, endDate) {
                  self.datas.publish_date = value;
                }
              });
            });
          }
        });

        //上架状态
        form.on('radio(is_listed)', function(data) {
          self.datas.is_listed = JSON.parse(data.value);
        });

        //Sku原价
        form.on('radio(skuprice)', function(data) {
          self.datas.skuprice = JSON.parse(data.value);
          localStorage.setItem("ExShopee_SkuPrice",data.value);
        });

        //输入框的值改变时触发
        $("#main-box").on("input propertychange", '.search-input', function(e) {
          var value = $(this).val();
          $(this).next().val(value)
          form.render();
          var dd = $(this).next().next();
          dd.find("dl").css({
            "display": "block"
          });
          var dl = dd.find("dl").children();
          var j = -1;
          for (var i = 0; i < dl.length; i++) {
            if (dl[i].innerHTML.indexOf(value) <= -1) {
              dl[i].style.display = "none";
              j++;
            }
            if (j == dl.length - 1) {
              dd.find("dl").css({
                "display": "none"
              });
            }
          }
        });

        //图片选中
        $("#main-box").on("click", '.col-select-box', function(e) {
          var checkbox = $(this).find(".layui-form-checkbox");
          if (checkbox.length != 0) {
            checkbox.click();
          }
        });

        //空间图片选中
        $("#main-box").on("click", '.space-select-box', function(e) {
          picix = $(this).attr("data-ix");
          console.log(picix)
          var child = $(this).prev().find("input[type='checkbox']");
          var status = child[0].checked;
          if (status) {
            self.Spaceimgs.pop();
            child[0].checked = false;
            $(".PictureSpace").find("li:eq(" + picix + ")").removeClass("img-active").attr("data-active",
              false);
          } else {
            if (self.etype == "sku" && self.Spaceimgs.length >= 1) {
              layer.msg("SKU属性只能选择一张图片！");
              return false;
            }
            self.Spaceimgs.push(picix);
            child[0].checked = true;
            $(".PictureSpace").find("li:eq(" + picix + ")").addClass("img-active").attr("data-active", true);
          }
          form.render('checkbox');
        });

        //添加属性
        var isDelete = false;
        $("#main-box").on("keydown", '.col-sku-input', function(e) {
          var ix = $(this).attr("data-ix");
          var val = $(this).val();
          if (e.keyCode == 8 && self.empty(val) && !isDelete) {
            if (self.datas.tier_variations.length > 0 && self.datas.tier_variations[ix].options.length > 0) {
              isDelete = true;
              self.datas.tier_variations[ix].options.pop()
              self.datas.tier_variations[ix].images.pop({isActive: false,url: null})

              self.CreateSkuArr(self.datas); //更新SKU表
              self.$forceUpdate();
              setTimeout(function() {
                isDelete = false;
              }, 200);
            }
          } else if (e.keyCode == 13) {
            if (self.empty(val)) {
              return;
            }

            for (let i in self.datas.tier_variations[ix].options) {
              if (self.datas.tier_variations[ix].options[i] == val) {
                layer.msg('该属性已存在，请勿重复添加！');
                return;
              }
            }

            self.datas.tier_variations[ix].options.push(val);
            if (ix == 0) {
              self.datas.tier_variations[ix].images.push({isActive: false,url: null});
            }
            $(this).val("");
            self.CreateSkuArr(self.datas); //更新SKU表
            self.$forceUpdate();
          }
        });

        //分类选择
        form.on('submit(classifybtn)', function(data) {
          self.datas.categories = self.categories;
          self.datas.isSpecial = self.categories[self.categories.length - 1].category_type;
          self.attributes = [];
          self.get_attributes(self.CurrentClassify);
          return false;
        });

        //选择分类
        $("#main-box").on('click', '.ClassifyMainRow', function() {
          var top = $(this).parent().scrollTop();
          var id = $(this).attr("data-id");
          var name = $(this).attr("data-name");
          var name_zh = $(this).attr("data-name_zh");
          var NoChildren = $(this).attr("data-children");
          var ctype = $(this).attr("data-ctype");
          var ix = $(this).attr("data-ix");
          var six = $(this).attr("data-six");
          // console.log(ix)
          // console.log(id)
          // console.log(NoChildren);

          //清除选中
          for (let i in self.categorieslist[ix]) {
            self.categorieslist[ix][i].istrue = false;
          }
          self.categorieslist[ix][six].istrue = true;
          self.categories.splice(ix, self.categories.length)
          self.categories[ix] = {
            catid: id,
            display_name: name,
            display_name_zh: name_zh,
            top: top,
            category_type: ctype
          }; //当前点击
          self.CurrentClassify = id; //当前ID
          self.get_categories(false, ix, id);

          if (NoChildren == "True") {
            $('.classifybtn').addClass("layui-btn-disabled").attr("disabled", true);
          } else {
            $('.classifybtn').removeClass("layui-btn-disabled").attr("disabled", false);
          }

        })

        //保存
        form.on('submit(save)', function(data) {
          var datas = self.datas;
          var etype = data.elem.dataset.etype;
          self.datas.attributes = self.attributes;

          self.loading = true;
          let param = new URLSearchParams()
          if (JSON.parse(self.te)) {
            if(self.datas.type != 3 && self.empty(etype)){
              param.append('type', self.te)
            }
          }
          if(self.itemid){
            param.append('itemid', self.itemid)
          }
          param.append('shop_id', self.shop.id)
          param.append('datas', JSON.stringify(datas))
          console.log(datas)
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/product_save/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            timeout: 60000,
          }).then(function(response) {
            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              localStorage.setItem("ExShopee_baglength", self.datas.baglength); //缓存包裹属性
              localStorage.setItem("ExShopee_bagwidth", self.datas.bagwidth); //缓存包裹属性
              localStorage.setItem("ExShopee_bagheight", self.datas.bagheight); //缓存包裹属性
              localStorage.setItem("ExShopee_HistoryURL", "Product");
              self.$router.push({
                path: "Product?ix=0"
              }) // 路由跳转
            }, false, true);
          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })

          return false;
        });

        //发布
        form.on('submit(release)', function(data) {
          var datas = self.datas;
          datas.attributes = self.attributes;

          //商品分类
          if (self.datas.categories.length <= 0) {
            layer.msg('商品分类不能为空！');
            self.PositionJump("shop-box");
            return;
          }

          //商品属性
          for (let i in self.datas.attributes) {
            if (self.datas.attributes[i].is_mandatory && !self.datas.attributes[i].current_select) {
              layer.msg('必选属性不能为空！');
              self.PositionJump("shop-box");
              return;
            }
          }

          var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
      　　if(self.shop.country != 'TW' && reg.test(datas.name)){
            layer.msg("标题包含中文！");
            self.PositionJump("title-box");
            return;
          }

          //标题检测
          self.TitleCheck(1);
          if (self.titleHint) {
            self.PositionJump("title-box");
            return;
          }

          //描述检测
          self.TitleCheck(2);
          if (self.desHint) {
            self.PositionJump("title-box");
            return;
          }

          //商品货号
          if (self.empty(self.datas.ProductCode)) {
            layer.msg('商品货号不能为空！');
            self.PositionJump("title-box");
            return;
          }

          //图片数量限制
          if (self.datas.images.length > self.imglength) {
            layer.msg('图片数量不能超过'+self.imglength+'张！');
            self.PositionJump("images-box");
            return;
          }

          //图片数量限制
          if (self.datas.images.length <= 0) {
            layer.msg('图片不能为空！');
            self.PositionJump("images-box");
            return;
          }

          //SKU数量提示
          if(self.datas.is_tier_variations && self.datas.customize_tier_variations.length > 50){
            layer.msg('SKU数量不能超过50个！');
            self.PositionJump("sku-box"); //位置跳转
            return;
          }

          //SKU属性长度判断
          for(let i in self.datas.tier_variations){
            for(let x in self.datas.tier_variations[i].options){
              if(self.datas.tier_variations[i].options[x].length > 30){
                layer.msg('SKU名称长度不能超过30字符！');
                self.PositionJump("sku-box"); //位置跳转
                return;
              }
            }
          }

          //SKU校验
          if(self.datas.is_tier_variations){

            if (!self.datas.customize_tier_variations || self.datas.customize_tier_variations.length <= 0) {
              layer.msg('规格属性不能为空！');
              self.PositionJump("sku-box"); //位置跳转
              return;
            }

            for(let i in self.datas.customize_tier_variations){
              if(self.datas.customize_tier_variations[i].weight && Number(self.datas.customize_tier_variations[i].weight) > Number(self.datas.weight)){
                self.datas.weight = JSON.parse(JSON.stringify(self.datas.customize_tier_variations[i].weight));
              }
              if(!self.datas.customize_tier_variations[i].price || self.datas.customize_tier_variations[i].price <= 0 || !self.datas.customize_tier_variations[i].price_before_discount || self.datas.customize_tier_variations[i].price_before_discount <= 0){
                layer.msg('属性价格不能为空！');
                let num = $("#sku-table")[0].offsetTop;
                self.PositionJump("sku-table",num); //位置跳转
                return;
              }
            }
          }else{
            if(self.empty(self.datas.price) || self.empty(self.datas.price_before_discount)){
              layer.msg('属性价格不能为空！');
              self.PositionJump("sku-box"); //位置跳转
              return;
            }
          }

          //SKU图片完整检测
          var isNull = [];
          if(self.datas.tier_variations && self.datas.tier_variations.length > 0){
            for(let i in self.datas.tier_variations[0].images){
              if(self.datas.tier_variations[0].images[i].url){
                isNull.push(self.datas.tier_variations[0].images[i]);
              }
              if(isNull.length > 0 && !self.datas.tier_variations[0].images[i].url){
                layer.msg("SKU图片不完整，只能全有或全无！");

                let num = $("#sku-imgs")[0].offsetTop;
                self.PositionJump("sku-imgs",num); //位置跳转
                return;
              }
            }
          }

          //包裹重量
          if (self.empty(self.datas.weight)) {
            layer.msg('包裹重量不能为空！');
            let num = $("#weight-box")[0].offsetTop;
            self.PositionJump("weight-box",num); //位置跳转
            return;
          }

          //物流方式
          let logs = [];
          for (let i in self.datas.logistics) {
            if (self.datas.logistics[i].enabled) {
              logs.push(self.datas.logistics[i]);
            }
          }
          if (logs.length <= 0) {
            layer.msg('物流方式不能为空！');
            self.PositionJump("log-box"); //位置跳转
            return;
          }

          //定时发布
          if (!self.datas.publish_now && !self.datas.publish_date) {
            layer.msg('请选择定时发布时间！');
            self.PositionJump("timing-box"); //位置跳转
            return;
          }

          //Sku名字组合
          if(datas.is_tier_variations){
            if(self.empty(datas.is_skuprice)){
              datas.is_skuprice = true;
              for(let i in datas.customize_tier_variations){
                //自动sku货号
                datas.customize_tier_variations[i].name = datas.ProductCode +"_"+ datas.customize_tier_variations[i].name;
                //自动sku原价
                if(datas.skuprice){
                  datas.customize_tier_variations[i].name = datas.models[i].price +"-"+ datas.customize_tier_variations[i].name;
                }
              }
            }
          }

          self.loading = true;
          let param = new URLSearchParams()
          if(self.itemid){
            if (JSON.parse(self.te)) {
              param.append('type', self.te)
            }
            param.append('itemid', self.itemid)
          }
          param.append('shop_id', self.shop.id)
          param.append('datas', JSON.stringify(datas))
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/product_add/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            timeout: 60000,
          }).then(function(response) {
            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              localStorage.setItem("ExShopee_baglength", self.datas.baglength); //缓存包裹属性
              localStorage.setItem("ExShopee_bagwidth", self.datas.bagwidth); //缓存包裹属性
              localStorage.setItem("ExShopee_bagheight", self.datas.bagheight); //缓存包裹属性
              localStorage.setItem("ExShopee_NavSubIx", 2); //导航缓存
              localStorage.setItem("ExShopee_HistoryURL", "Product");
              let navix = 1;
              if(!self.datas.publish_now){
                navix = 4;
              }
              self.$router.push({
                path: "Product?ix="+navix
              }) // 路由跳转
            }, false, true);
          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })

          return false;
        });

        //促销选择
        form.on('submit(PromotionSubmit)', function(data) {
          self.datas.discount_info = {
            id: data.elem.dataset.id,
            name: data.elem.dataset.name
          };
          self.$forceUpdate();
          self.modal_box_close();
          return false;
        });

        //图片上传
        $("#main-box").on("change", ".upload_img", function(event) {
          var _this = $(this);
          let te = $(this).attr("data-te");
          let ix = $(this).attr("data-ix");
          var $file = event.currentTarget;
          var formData = new FormData();
          var file = $file.files;

          for (var i = 0; i < file.length; i++) {
            formData.append(file[i].name, file[i]);
          }

          self.loading = true;
          $.ajax({
            url: self.GetServerUrl() + "/update_file/",
            type: 'post',
            dataType: 'json',
            data: formData,
            contentType: false,
            processData: false,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              if (res.code == 200) {
                _this.val(""); //清空图片选中
                let datas = res.datas;
                if (te == "sku") {
                  self.datas.tier_variations[0].images[ix].url = datas[0];
                } else if (te == "pro") {
                  for (let i in datas) {

                    var img = new Image();
                    img.src = datas[i];
                    img.onload = function() {
                      self.loading = false;
                      self.datas.images.push({
                        isActive: false,
                        url: datas[i],
                        size: img.width + "x" + img.height
                      });
                    };

                  }
                } else if (te == "waterprint") {
                  $("#WaterPImg").attr("src", datas[0]);
                  self.WaterPLocation();
                }
              } else {
                layer.msg(res.msg);
              }
            },
            error: function(error) {
              self.loading = false;
              self.ToastFun(2, error); //弹窗提醒
            }
          })
        })

        //SKU编辑
        $("#main-box").on('keydown', '.layui-layer-input', function(event) {
          if (event.keyCode == 13) {
            let text = event.target.value;
            if (editType == "all") {
              //价格、折扣只能为数字
              if (allType != 'name' && (isNaN(text) || text == " ")) {
                layer.msg("请输入纯数字！");
                return;
              }
              if(!text && allType != "weight"){
                return;
              }
              for (let i in self.datas.customize_tier_variations) {
                eval('self.datas.customize_tier_variations[i].' + allType + '= text');

                //自动计算
                var models = self.datas.customize_tier_variations;
                for (let m in models) {
                  let price = models[m].price;
                  let sprice = models[m].price_before_discount;
                  if (price && sprice) {

                    if (allType == "diskaun") {
                      price = text * 0.1 * sprice;
                      if (price > 100) {
                        models[m].price = price.toFixed(0);
                      } else {
                        models[m].price = price.toFixed(2);
                      }
                      models[m].diskaun = (Number(text)).toFixed(1);
                    } else {
                      let diskaun = ((price / sprice) * 10).toFixed(1);
                      models[m].diskaun = diskaun;
                    }

                  }
                }
              }
            } else {
              for (let i in self.datas.tier_variations[skuinfo.ix].options) {
                if (self.datas.tier_variations[skuinfo.ix].options[i] == text) {
                  layer.msg('该属性已存在，请勿重复添加！');
                  return;
                }
              }
              if(text.length > 30){
                layer.msg('长度'+text.length+'，字符长度不能超过30位！');
                return;
              }
              self.EditFun(skuinfo.ix, skuinfo.six, text);
            }

            layer.closeAll();
          }
        });

        //文字提示
        var tips;
        $("#main-box").on('mouseenter', '.tipsBox', function(event) {
          let ix = $(this).attr("data-ix");
          let txt = self.attributes[ix].attribute_name;
          if (self.attributes[ix].attribute_name_zh) {
            txt += "(" + self.attributes[ix].attribute_name_zh + ")"
          }
          tips = layer.tips(txt, '.tips' + ix, {
            tips: 4,
            time: 999999
          });
        });
        $("#main-box").on('mouseleave', '.tipsBox', function(event) {
          layer.close(tips);
        });

        //批量编辑提示
        var tips;
        $("#main-box").on('mouseenter', '.BulkEditTips', function(event) {
          let pix = $(this).attr("data-pix");
          tips = layer.tips("点击批量编辑", '.Tips' + pix, {
            tips: 1,
            time: 999999
          });
        });
        $("#main-box").on('mouseleave', '.BulkEditTips', function(event) {
          layer.close(tips);
        });

        //批量编辑
        $("#main-box").on('click', '.BulkEditTips', function(event) {
          let pix = $(this).attr("data-pix");
          let te = $(this).attr("data-te");
          allType = te, editType = "all"; //回车触发类型
          layer.prompt({
            title: '批量编辑',
            formType: 3,
            yes: function(index, layero) {
              var pass = layero.find(".layui-layer-input").val();

              for (let i in self.datas.customize_tier_variations) {
                //价格、折扣只能为数字
                if (te != 'name' && (isNaN(pass) || pass == " ")) {
                  layer.msg("请输入纯数字！");
                  return;
                }
                if(!pass && te != "weight"){
                  return;
                }
                eval('self.datas.customize_tier_variations[i].' + te + '= pass');

                //自动计算
                var models = self.datas.customize_tier_variations;
                for (let m in models) {
                  let price = models[m].price;
                  let sprice = models[m].price_before_discount;
                  if (price && sprice) {

                    if (te == "diskaun") {
                      price = pass * 0.1 * sprice;
                      if (price > 100) {
                        models[m].price = price.toFixed(0);
                      } else {
                        models[m].price = price.toFixed(2);
                      }
                      models[m].diskaun = (Number(pass)).toFixed(1);
                    } else {
                      let diskaun = ((price / sprice) * 10).toFixed(1);
                      models[m].diskaun = diskaun;
                    }

                  }
                }
              }
              self.$forceUpdate();
              layer.close(index);
            }
          });
        });

        self.get_shop_list(); //店铺列表
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {

        }
      },
      get_shop_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              for (let item in datalist) {
                if (item == 0) {
                  datalist[item].NavActive = true;
                } else {
                  datalist[item].NavActive = false;
                }
              }

              self.shops = datalist;
              self.shop = datalist[0];
              self.navlist.push(datalist[0]);

              //西班牙图片
              if(self.shop.country == "ES"){
                self.imglength = 20;
              }

              self.get_product_info();
            }
          }, function(e) {
            self.get_product_info();
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_product_info() {
        var _url = '/collection_detail/'
        if (JSON.parse(self.te)) {
          _url = '/production_detail/' //发布列表
        }
        var datas = {id: self.itemid}
        if(self.shop){
          datas.shop_id = self.shop.id;
        }

        $.ajax({
          url: self.GetServerUrl() + _url,
          type: 'post',
          data: datas,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.isLoding = false;
            var json = JSON.parse(res);
            if (json.code == 200) {
              var datas = json.datas;
              var models = datas.models;

              for (var item in models) {
                models[item].list = models[item].name.split(",");
                if (models[item].price && models[item].price_before_discount) {
                  models[item].diskaun = (models[item].price / models[item].price_before_discount * 10).toFixed(
                    1)
                }
                models[item].weight = null;
                models[item].istrue = true;
                models[item].modelid = item;
                // models[item].name = models[item].name +'_￥'+ models[item].price;
              }

              //图片列表
              if (datas.images) {
                datas.imagesBackup = JSON.parse(JSON.stringify(datas.images));
                var x = 0,
                  imgobj = {};
                for (var img in datas.images) {
                  if (datas.images[img].hasOwnProperty("isActive")) {
                    datas.images[img].isActive = false; //初始化选中
                  } else {
                    datas.images[img] = {
                      isActive: false,
                      url: datas.images[img]
                    };
                  }
                  if (!datas.images[img].hasOwnProperty("size")) {
                    console.log("图片属性加载！");
                    if (!imgobj.hasOwnProperty(img)) {
                      imgobj[img] = []
                    }
                    imgobj[img] = new Image()
                    imgobj[img].src = datas.images[img].url;
                    imgobj[img].onload = function() {
                      x++;
                      if (datas.images.length == x) {
                        for (let y in datas.images) {
                          datas.images[y].size = imgobj[y].width + "x" + imgobj[y].height;
                        }
                        self.datas.images = datas.images;
                        self.datas.imagesBackup = JSON.parse(JSON.stringify(datas.images));
                        self.$forceUpdate();
                      }
                    };
                  }
                }
              }

              //初始化字段
              if(self.empty(datas.ProductCode)){
                datas.ProductCode = "HLKJ" + self.itemid;
              }
              if (self.empty(datas.is_pre_sale)) {
                datas.is_pre_sale = false;
              }
              if (self.empty(datas.pre_sale)) {
                datas.pre_sale = 5;
              }
              if (datas.price && datas.price_before_discount) {
                datas.diskaun = (datas.price / datas.price_before_discount * 10).toFixed(1)
              }

              //默认是否选中SKU原价
              if(!self.empty(localStorage.getItem("ExShopee_SkuPrice"))){
                datas.skuprice = true;
              }else{
                datas.skuprice = false;
              }

              //SKU原价删减，防止影响编辑
              if(datas.is_skuprice){
                datas.is_skuprice = false;
                for(let x in datas.customize_tier_variations){
                  let name = datas.customize_tier_variations[x].name;
                  let fix = name.indexOf("_");
                  if(fix != -1){
                    datas.customize_tier_variations[x].name = name.substring(fix+1,name.length);
                  }
                }
              }

              if (!datas.hasOwnProperty("publish_now")) {
                datas.publish_now = true;
              } else {
                self.$nextTick(() => {
                  laydate.render({
                    elem: '#publish_date',
                    type: 'datetime',
                    min: 0,
                    max: 15,
                    trigger: 'click',
                    done: function(value, date, endDate) {
                      self.datas.publish_date = value;
                    }
                  });
                });
              }
              if (!datas.hasOwnProperty("is_listed")) {
                datas.is_listed = true;
              }

              //包裹尺码
              if (!self.empty(localStorage.getItem("ExShopee_baglength"))) {
                datas.baglength = localStorage.getItem("ExShopee_baglength");
              }else{
                datas.baglength = 5
              }
              if (!self.empty(localStorage.getItem("ExShopee_bagwidth"))) {
                datas.bagwidth = localStorage.getItem("ExShopee_bagwidth");
              }else{
                datas.bagwidth = 5
              }
              if (!self.empty(localStorage.getItem("ExShopee_bagheight"))) {
                datas.bagheight = localStorage.getItem("ExShopee_bagheight");
              }else{
                datas.bagheight = 5
              }

              //初始化SKU类型
              datas.limit = 0
              if (datas.tier_variations && datas.tier_variations.length > 0 && !self.empty(datas.tier_variations[0].name)) {

                //图片为空时初始化
                for (let v in datas.tier_variations) {
                  if (!(datas.tier_variations[v]).hasOwnProperty("images")) {
                    datas.tier_variations[v].images = [];
                  }
                }

                if(!datas.hasOwnProperty("is_tier_variations")){
                  datas.is_tier_variations = true;
                }

                //自定义SKU
                // datas.customize_tier_variations = self.CreateSkuArr(datas);
                if (self.empty(datas.customize_tier_variations)) {
                  datas.customize_tier_variations = JSON.parse(JSON.stringify(models)); //拷贝层
                }

                //Sku图片列表
                for(let s in datas.tier_variations[0].images){
                  if (datas.tier_variations[0].images[s].hasOwnProperty("isActive")) {
                    datas.tier_variations[0].images[s].isActive = false; //初始化选中
                  } else {
                    datas.tier_variations[0].images[s] = {
                      isActive: false,
                      url: datas.tier_variations[0].images[s]
                    };
                  }
                }

              } else {
                datas.is_tier_variations = false;
                if (!datas.stock) {
                  // datas.stock = 999
                }
                if (!datas.diskaun && datas.price && datas.price_before_discount) {
                  datas.diskaun = (datas.price / datas.price_before_discount * 10).toFixed(1)
                }
              }

              //自动匹配店铺
              if (datas.shop_id) {
                for (let s in self.shops) {
                  self.shops[s].isSelect = false;
                  if (self.shops[s].id == datas.shop_id) {
                    self.shops[s].isSelect = true;
                    self.shop = self.shops[s];
                  }
                }
                self.$forceUpdate();
              } else if (datas.country) {
                let isSelect = false;
                for (let s in self.shops) {
                  self.shops[s].isSelect = false;
                  if (self.shops[s].country == datas.country) {
                    self.shops[s].isSelect = true;
                    self.shop = self.shops[s];
                    isSelect = true
                  }
                }
                if (!isSelect) {
                  self.shops[0].isSelect = true;
                }
              }

              //加载选择项
              if (datas.categories && datas.categories.length > 0) {
                self.default_attributes = datas.attributes;

                //货物类型判断
                if(datas.categories[datas.categories.length - 1].category_type == 1){
                  datas.isSpecial = true;
                }else{
                  datas.isSpecial = false;
                }

                //属性不为空直接填充
                if (datas.attributes && datas.attributes.length > 0) {
                  for (let i in datas.attributes) {

                    //重置品牌
                    if (datas.attributes[i].attribute_name == "Brand") {
                      datas.attributes[i].options = ["NoBrand"]
                      datas.attributes[i].values = ["NoBrand"]
                      datas.attributes[i].current_select = "NoBrand"
                      datas.attributes[i].current_select_en = "NoBrand"
                    }

                    //翻译组合
                    if (datas.attributes[i].options) {
                      datas.attributes[i].options_cn = JSON.parse(JSON.stringify(datas.attributes[i].options));
                      for (let x in datas.attributes[i].options) {
                        if (datas.attributes[i].options_zh && datas.attributes[i].options_zh[x]) {
                          datas.attributes[i].options_cn[x] = datas.attributes[i].options[x] + "(" +
                            datas.attributes[
                              i].options_zh[x] + ")"
                        }
                      }
                    } else {
                      self.get_attributes(datas.categories[datas.categories.length - 1].catid);
                    }
                  }
                  self.attributes = datas.attributes;
                } else {
                  self.get_attributes(datas.categories[datas.categories.length - 1].catid);
                }

              } else {
                self.get_categories(true); //自动填充分类
              }

              //快递方式
              if (self.empty(datas.logistics)) {
                self.get_logistics(); //快递方式
              }

              console.log(datas)
              self.datas = datas;
              self.datas_Backup = JSON.parse(JSON.stringify(datas));
              self.TitleCheck(1);
              self.TitleCheck(2);

              if(self.shop){
                self.get_discounts_list(); //促销活动
                self.get_pricing(); //定价模板
              }

            } else if (json.code == 401) {

            } else {
              //创建商品初始化内容
              var datas = {
                ProductCode:null,
                attributes: [],
                bagheight: null,
                baglength: null,
                bagwidth: null,
                categories: [],
                discount_info:null,
                customize_tier_variations: [],
                description: null,
                diskaun: null,
                images: [],
                is_listed:true,
                skuprice:true,
                is_pre_sale: false,
                is_tier_variations: false,
                itemid: null,
                limit: 0,
                logistics: [],
                models: [],
                name: null,
                origin: null,
                pre_sale: null,
                price: null,
                price_before_discount: null,
                publish_now: true,
                stock: null,
                tier_variations: []
              }
              //包裹尺码
              if (!self.empty(localStorage.getItem("ExShopee_baglength"))) {
                datas.baglength = localStorage.getItem("ExShopee_baglength");
              }else{
                datas.baglength = 5
              }
              if (!self.empty(localStorage.getItem("ExShopee_bagwidth"))) {
                datas.bagwidth = localStorage.getItem("ExShopee_bagwidth");
              }else{
                datas.bagwidth = 5
              }
              if (!self.empty(localStorage.getItem("ExShopee_bagheight"))) {
                datas.bagheight = localStorage.getItem("ExShopee_bagheight");
              }else{
                datas.bagheight = 5
              }
              self.datas = datas;
              self.get_discounts_list(); //促销活动
              self.get_pricing(); //定价模板
              self.get_logistics(); //快递方式
            }

            //下拉翻译
            self.$nextTick(() => {
              dropdown.render({
                elem: '.translation-img'
              // ,trigger: 'hover'
                ,data: [{
                  title: '阿里翻译（实时低至0.028/次）'
                  ,child: self.LanguageList(1)
                },{
                  title: '免费翻译（速度慢易失败）'
                  ,child: self.LanguageList(0)
                }]
                ,click: function(obj){
                  self.SelectLanguage(obj.type,obj.id);
                }
              });
            });

          },
          error: function() {
            self.isLoding = false;
          }
        })
      },
      get_categories(te, ix, id, click) {
        var datas = {
          shop_id: self.shop.id
        }
        if (id) { //上级ID
          datas.category_id = id;
        }
        if (te) { //是否需要自动填充
          datas.itemid = self.itemid;
        }

        //发布列表
        if (JSON.parse(self.te)) {
          datas.type = self.te;
        }
        $.ajax({
          url: self.GetServerUrl() + '/get_categories/',
          type: 'post',
          data: datas,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            var json = JSON.parse(res);
            if (json.code == 200) {
              if (!ix) {
                self.categorieslist = [json.datas.category]
                let categories = json.datas.categories;
                if (categories.length > 0) {
                  self.datas.categories = categories;
                  self.get_attributes(categories[categories.length - 1].catid); //加载商品属性
                } else {
                  if (click) {
                    self.modal_box_show(self, 'Categories', '选择分类', self.categorieslist);
                  }
                }
              } else {
                var cix = parseInt(ix) + 1;
                self.categorieslist.splice(cix, self.categorieslist.length); //先删除下级
                if (json.datas.category.length > 0) {
                  self.categorieslist[cix] = json.datas.category;
                }
                self.ClassifyHtml(self.categorieslist);
              }
            } else if (json.code == 401) {

            } else {
              console.log(json.msg);
            }
          }
        })
      },
      get_attributes(cid, clist) {
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + '/get_attributes/',
          type: 'post',
          data: {
            category_id: cid,
            shop_id: self.shop.id,
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.loading = false;
            var json = JSON.parse(res);
            if (json.code == 200) {
              var attributes = json.datas.data;
              var mandatory = json.datas.mandatory_ids;
              for (var item in attributes) {

                //重置品牌
                if (attributes[item].attribute_name == "Brand") {
                  attributes[item].options = ["NoBrand"]
                  attributes[item].values = ["NoBrand"]
                  attributes[item].current_select = "NoBrand"
                  attributes[item].current_select_en = "NoBrand"
                }

                //不为空初始化
                if (self.empty(attributes[item].current_select)) {
                  attributes[item].current_select = null
                }
                if (self.empty(attributes[item].current_select_en)) {
                  attributes[item].current_select_en = null
                }

                for (let z in self.default_attributes) {
                  if (self.default_attributes[z].name == attributes[item].attribute_name) {
                    attributes[item].current_select = self.default_attributes[z].value;
                  }
                }

                //必填项筛选
                for (let i in mandatory) {
                  if (mandatory[i] == attributes[item].attribute_id) {
                    attributes[item].is_mandatory = true;
                  }
                }

                //翻译组合
                attributes[item].options_cn = JSON.parse(JSON.stringify(attributes[item].options));
                for (let x in attributes[item].options) {
                  if (attributes[item].options_zh && attributes[item].options_zh[x]) {
                    attributes[item].options_cn[x] = attributes[item].options[x] + "(" + attributes[item]
                      .options_zh[
                        x] + ")"
                  }
                }

                //首行不选中
                if (attributes[item].attribute_name == "Brand") {
                  attributes[item].attribute_name_zh = "品牌"
                } else {
                  //默认选中
                  var attr = self.datas.attributes;
                  for (let j in attr) {
                    if(self.datas.type == "shopee"){
                      if (attr[j].name == attributes[item].attribute_name) {
                        attributes[item].current_select = attr[j].value;
                        attributes[item].current_select_en = attr[j].value;
                      }
                    }else{
                      if (attr[j].attribute_name == attributes[item].attribute_name) {
                        attributes[item].current_select = attr[j].current_select;
                        attributes[item].current_select_en = attr[j].current_select_en;
                      }
                    }
                  }
                }
              }
              self.attributes = attributes;
              self.modal_box_close();
              self.$forceUpdate();
            } else if (json.code == 401) {

            } else {
              console.log(json.msg);
            }
          },
          error: function() {
            self.loading = false;
          }
        })
      },
      get_logistics() {
        $.ajax({
          url: self.GetServerUrl() + '/get_logistics/',
          type: 'post',
          data: {
            shop_id: self.shop.id,
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            var json = JSON.parse(res);
            if (json.code == 200) {
              var logistics = json.datas.logistics;
              for (let i in logistics) {
                logistics[i].isFree = false;
              }
              self.datas.logistics = logistics;
              self.$forceUpdate();
            } else if (json.code == 401) {

            } else {
              console.log(json.msg);
            }
          }
        })
      },
      get_discounts_list(etype) {
        $.ajax({
          url: self.GetServerUrl() + '/get_discounts_list/',
          type: 'post',
          data: {
            shop_id: self.shop.id,
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            var json = JSON.parse(res);
            self.loading = false;
            if (json.code == 200) {
              var discounts = json.datas.discount;
              self.discounts = discounts;

              if(etype){
                var chtml = ""
                for (var i in discounts) {
                  chtml += '<tr>'
                	chtml += '<td>'+ discounts[i].discount_id +'</td>'
                	chtml += '<td>'+discounts[i].discount_name+'</td>'
                	chtml += '<td>'
                  if(discounts[i].status == "upcoming"){
                    chtml += '<i class="status-box status-box-red">即将开始的活动</i>'
                  }else{
                    chtml += '<i class="status-box status-box-red">进行中</i>'
                  }
                  chtml += '</td>'
                	chtml += '<td>'
                	chtml += '<div>开始：'+self.timestampToTime(discounts[i].start_time)+'</div>'
                	chtml += '<div>结束：'+self.timestampToTime(discounts[i].end_time)+'</div>'
                	chtml += '</td>'
                	chtml += '<td><button class="layui-btn layui-btn-normal" lay-filter="PromotionSubmit" data-id="'+discounts[i].discount_id +'" data-name="'+discounts[i].discount_name+'" type="button" lay-submit>选择</button></td>'
                	chtml += '</tr>'
                }
                $("#table-html").html(chtml);
              }
            } else if (json.code == 401) {

            } else {
              console.log(json.msg);
            }
          },
          error:function(){
            self.loading = false;
          }
        })
      },
      get_pricing() {
        let param = new URLSearchParams()
        axios({
          method: 'post',
          data: param,
          url: self.GetServerUrl() + "/price_template_list/?is_page=0",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(json) {
            var datas = json.list;
            for (let item in datas) {
              datas[item].is_select = datas[item].is_default;
              if (!datas[item].name) {
                datas[item].name = "定价模板" + datas[item].id
              }
            }
            self.pricing = datas;
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      beautifyImg(itype, ix, img) {
        const imgs = editor.importFile(img);
        // 如果 res 为 false 表示没有进行导出操作
        if (imgs) {
          // files 为导出的文件数组， urls 为导出的文件 url 地址
          const {
            files
          } = imgs.then(imgs => {
              var fileimgs = imgs.files;

              //.then是接收正确返回的信息
              if (fileimgs && fileimgs.length > 0) {

                var formData = new FormData();
                for (var i = 0; i < fileimgs.length; i++) {
                  formData.append(fileimgs[i].name, fileimgs[i]);
                }

                self.loading = true;
                $.ajax({
                  url: self.GetServerUrl() + "/update_file/",
                  type: 'post',
                  dataType: 'json',
                  data: formData,
                  contentType: false,
                  processData: false,
                  headers: {
                    'token': localStorage.getItem("ExShopee_token")
                  },
                  success: function(res) {
                    self.loading = false;
                    if (res.code == 200) {
                      let datas = res.datas;
                      console.log(datas)
                      if (itype == "pro") {
                        self.datas.images[ix] = {
                          isActive: false,
                          url: datas[0]
                        };
                      } else {
                        self.datas.tier_variations[0].images[ix].url = datas[0];
                      }
                    } else {
                      layer.msg(res.msg);
                    }
                  },
                  error: function(error) {
                    self.loading = false;
                    self.ToastFun(2, error); //弹窗提醒
                  }
                })
              }

            })
            .catch(err => {
              console.log(err) //.catch 返回报错信息
            })

        }
      },
      deletefile(ix, te) {
        if (te == 1) { //视频
          self.datas.video_info_list[ix] = null;
        } else if (te == 2) { //SKU图片
          let deletebox = layer.confirm('选择删除类型', {
            title: "系统提示",
            btn: ['仅删除图片', '删除图片和此规格'] //按钮
          }, function() {
            self.datas.tier_variations[0].images[ix].url = null;
            layer.close(deletebox);
            self.$forceUpdate();
          }, function() {
            self.datas.tier_variations[0].images.splice(ix, 1);
            self.datas.tier_variations[0].options.splice(ix, 1);
            self.CreateSkuArr(self.datas); //更新SKU表
          });
        } else {
          self.datas.images.splice(ix, 1);
        }
        self.$forceUpdate();
      },
      inputFun(e) {
        var ix = e.target.dataset.ix;
        var txt = e.target.value;
        $("#log_select").next().find("dl").css({
          "display": "block"
        });
      },
      promotion() {
        self.modal_box_show(self, 'PromotionList', '促销活动', self.discounts);
      },
      AddPromotion() {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
          if(w > 500){
            w = 500;
          }
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
          if(h > 410){
            h = 410;
          }
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "添加活动",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: PromotionAdd,
          success: function() {
            laydate.render({
              elem: '#start_date',
              type: 'datetime',
              min: 0,
              max: 180,
            });
            laydate.render({
              elem: '#end_date',
              type: 'datetime',
              min: 0,
              max: 180,
            });

            form.render();
          },
          yes: function(index, layero) {
            let name = $("#promotion_name").val();
            let start_date = $("#start_date").val();
            let end_date = $("#end_date").val();
            if(self.empty(name)){
              layer.msg("促销名称不能为空！");
              return;
            }
            if(self.empty(start_date) && self.empty(end_date)){
              layer.msg("促销时间不能为空！");
              return;
            }

            let param = new URLSearchParams()
            param.append('shop_id', self.shop.id);
            param.append('discount_name', name);
            param.append('start_time', start_date);
            param.append('end_time', end_date);
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + '/add_discounts/',
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(res) {
              var json = res.data;
              layer.msg(json.msg);
              if (json.code == 200) {
                self.get_discounts_list(true); //促销活动
                layer.close(xmlModule);
              }else{
                self.loading = false;
              }
            }).catch(function(error) {
              self.loading = false;
              layer.msg(error);
            })

          }
        });
      },
      deleteSku(te, ix, six) {
        if (te == 2) {
          self.datas.tier_variations[ix].options.splice(six, 1);
          self.datas.tier_variations[ix].images.splice(six, 1);
        } else {
          self.datas.tier_variations.splice(ix, 1);
        }

        self.CreateSkuArr(self.datas); //更新SKU表
      },
      AddSku() {
        self.datas.tier_variations.push({
          images: [],
          name: null,
          options: []
        });
      },
      EditSku(ix, six, txt) {
        editType = "one"; //回车触发类型
        skuinfo = {
          ix: ix,
          six: six,
          txt: txt
        };
        layer.prompt({
          title: '属性修改',
          value: txt
        }, function(text, index) {
          for (let i in self.datas.tier_variations[ix].options) {
            if (self.datas.tier_variations[ix].options[i] == text) {
              layer.msg('该属性已存在，请勿重复添加！');
              return;
            }
          }
          if(text.length > 30){
            layer.msg('长度'+text.length+'，字符长度不能超过30位！');
            return;
          }
          self.EditFun(ix, six, text);
          layer.close(index);

        });
      },
      EditFun(ix, six, text) {

        //修改ModelSKU名称以防更改后无法匹配上
        var models = self.datas.models;
        var customize_tier_variations = self.datas.customize_tier_variations;
        for (let i in models) {
          if ((models[i].list[ix].toLowerCase()).replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "") == (self.datas
              .tier_variations[
                ix].options[six].toLowerCase()).replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "")) {
            models[i].list[ix] = text;
            let name = "";
            for (let x in models[i].list) {
              if (x == models[i].list.length - 1) {
                name += models[i].list[x]
              } else {
                name += models[i].list[x] + ','
              }
            }
            models[i].name = name;
            customize_tier_variations[i].name = name;
          }
        }
        self.datas.tier_variations[ix].options[six] = text;
        self.CreateSkuArr(self.datas); //更新SKU表
      },
      CreateSkuArr(datas, backup) {
        var skulist = [];
        var models = self.datas.models;
        var customize_tier_variations = self.datas.customize_tier_variations;
        if (backup) {
          models = JSON.parse(JSON.stringify(self.datas_Backup.models));
          customize_tier_variations = JSON.parse(JSON.stringify(self.datas_Backup.customize_tier_variations));
        }
        if (datas.tier_variations && datas.tier_variations.length > 0) {
          if (datas.tier_variations[0].options.length > 0) {
            for (let y in datas.tier_variations[0].options) {

              var sku1 = datas.tier_variations[0].options[y];
              if (datas.tier_variations.length > 1 && datas.tier_variations[1].options.length > 0) { //二级SKU
                for (let z in datas.tier_variations[1].options) {
                  var sku2 = datas.tier_variations[1].options[z];
                  skulist.push({
                    name: sku1 + ',' + sku2,
                    list: [sku1, sku2],
                    stock: 999,
                    price: null,
                    price_before_discount: null,
                    istrue: true,
                    diskaun: null
                  })
                }
              } else { //一级SKU

                for (let m in models) {
                  if (models[m].list[0] == sku1) {
                    models[m].name = sku1;
                    customize_tier_variations[m].name = sku1;
                  }
                }

                skulist.push({
                  name: sku1,
                  list: [sku1],
                  stock: 999,
                  price: null,
                  price_before_discount: null,
                  istrue: true,
                  diskaun: null
                })
              }

            }
          } else if (datas.tier_variations.length > 1 && datas.tier_variations[1].options.length > 0) { //二级SKU
            for (let z in datas.tier_variations[1].options) {
              var sku2 = datas.tier_variations[1].options[z];

              for (let m in models) {
                if (models[m].list[1] == sku2) {
                  models[m].name = sku2;
                  customize_tier_variations[m].name = sku2;
                }
              }

              skulist.push({
                name: sku2,
                list: ['', sku2],
                stock: 999,
                price: null,
                price_before_discount: null,
                istrue: true,
                diskaun: null
              })
            }
          }
        }

        //models价格、库存填充
        for (let q in models) {
          for (let w in skulist) {
            if ((models[q].name.toLowerCase()).replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "") == (skulist[
                w].name.toLowerCase())
              .replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "")) { //索引校验
              skulist[w].modelid = models[q].modelid;
              skulist[w].price = models[q].price;
              skulist[w].stock = models[q].stock;
              skulist[w].price_before_discount = models[q].price_before_discount;
              skulist[w].istrue = true,
                skulist[w].diskaun = models[q].diskaun;
            }
          }
        }
        self.datas.models = JSON.parse(JSON.stringify(skulist));

        //customize_tier_variations价格、库存填充
        for (let q in customize_tier_variations) {
          for (let w in skulist) {
            if ((customize_tier_variations[q].name.toLowerCase()).replace(
                /[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "") ==
              (skulist[w].name.toLowerCase())
              .replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "")) { //索引校验
              skulist[w].modelid = customize_tier_variations[q].modelid;
              skulist[w].price = customize_tier_variations[q].price;
              skulist[w].stock = customize_tier_variations[q].stock;
              skulist[w].price_before_discount = customize_tier_variations[q].price_before_discount;
              skulist[w].istrue = true,
                skulist[w].diskaun = customize_tier_variations[q].diskaun;
            }
          }
        }
        self.datas.customize_tier_variations = JSON.parse(JSON.stringify(skulist));
        self.$forceUpdate();
      },
      ClassifyHtml(datas) {
        if (self.categories.length > 0) {
          var xhtml = '<a>正在选择的：</a>'
          for (var val in self.categories) {
            xhtml += '<a class="redtxt">' + self.categories[val].display_name_zh + '「' + self.categories[val].display_name +
              '」' + '</a>'
            if (val < self.categories.length - 1) {
              xhtml += '<a class="redtxt"> > </a>'
            }
          }
          $(".ClassifyHeadLeft").html(xhtml);
        }

        var chtml = ""
        for (var item in datas) {
          if (self.categories[item] && self.categories[item].top) {
            chtml += '<div class="swiper-slide ClassifyMain" data-top="' + self.categories[item].top + '">'
          } else {
            chtml += '<div class="swiper-slide ClassifyMain" data-top="0">'
          }
          for (let i in datas[item]) {
            if (datas[item][i].istrue) {
              chtml += '<li class="ClassifyMainRow ClassifyMainActive" data-ix="' + item + '" data-name="' +
                datas[item]
                [i].category_name + '" data-name_zh="' + datas[item][i].category_name_zh + '" data-six="' + i +
                '" data-id="' +
                datas[item][i].category_id + '" data-children="' + datas[item][i].has_children +
                '" data-ctype="' + datas[item][i].category_type + '">'
            } else {
              chtml += '<li class="ClassifyMainRow" data-ix="' + item + '" data-name="' + datas[item][i].category_name +
                '" data-name_zh="' + datas[item][i].category_name_zh + '" data-six="' + i + '" data-id="' +
                datas[item]
                [i].category_id + '" data-children="' + datas[item][i].has_children +
                '" data-ctype="' + datas[item][i].category_type + '">'
            }
            chtml += '<a>' + datas[item][i].category_name_zh + '</a>'
            chtml += '<a style="color:#888;">' + datas[item][i].category_name + '</a>'
            if (datas[item][i].has_children == "True") {
              chtml += '<i class="fa fa-angle-right ClassifyMainIcon"></i>'
            }
            chtml += '</li>'
          }
          chtml += '</div>'
        }
        $("#ClassifyBox").html(chtml);

        $(".ClassifyMain").each(function() {
          var top = $(this).attr("data-top");
          $(this).scrollTop(top);
        })

        self.$forceUpdate();

        var mySwiper = new Swiper('.swiper-container', {
          slidesPerView: 'auto',
          observer: true,
          observerParents: true
        })
      },
      ShowClassify: function() {
        self.categories = []; //清空预览分类
        self.get_categories(false, false, false, true);
      },
      SaleDay(e) {
        var val = self.datas.pre_sale;
        if (isNaN(val)) {
          self.datas.pre_sale = 5;
        } else {
          if (val < 5) {
            self.datas.pre_sale = 5;
          } else if (val > 10) {
            self.datas.pre_sale = 10;
          }
        }
      },
      KeepPicture() {
        self.datas.images.splice(self.imglength, self.datas.images.length)
      },
      ClosePage() {
        this.$router.go(-1); //返回上一层
        // window.close();
      },
      CountPrice() {
        let weight = self.datas.weight; //定价模板
        let te = self.datas.is_tier_variations;

        let isNull = true;
        for (let x in self.datas.customize_tier_variations) {
          if (self.datas.customize_tier_variations[x].weight) {
            isNull = false;
          }
        }
        if (self.empty(weight) && isNull) {
          layer.msg("重量不能为空！"); //弹窗提醒
          return;
        }

        //单SKU和多SKU
        var variations;
        if (te) {
          variations = JSON.parse(JSON.stringify(self.datas.customize_tier_variations)); //变体价格
        } else {
          variations = [{
            price: self.datas.price,
            price_before_discount: self.datas.price_before_discount,
            istrue: true
          }]; //变体价格
        }

        let country = self.shop.country; //当前站点
        let pricing = self.pricing; //定价模板
        let cpricing; //当前选中模板
        for (let i in pricing) {
          if (pricing[i].is_select == 1) {
            cpricing = pricing[i];
          }
        }
        if (!cpricing && pricing.length > 0) {
          cpricing = pricing[0]
        }
        self.PricingTool(country, weight, variations, cpricing, te)

      },
      translation() {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('country', self.shop.country)
        param.append('data', JSON.stringify(self.datas))
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/translation/",
          data: param,
          timeout: 10000,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            console.log(datas)
            self.datas = datas;
            self.TitleCheck(1); //翻译后重新检测标题
            self.TitleCheck(2); //翻译后重新检测描述
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      OpenPage(url) {
        localStorage.setItem("ExShopee_NavSubIx", 0);
        window.open(self.GetServerLink() + '#/' + url);
      },
      InputDetection(name, origin, te, ix) {
        var price, diskaun, price_before_discount;
        var _price, _diskaun;
        if (origin == 1) {
          //价格、折扣、重量、库存只能为数字
          if (isNaN(eval('self.datas.' + name)) || eval('self.datas.' + name) == " ") {
            eval('self.datas.' + name + '= self.datas_Backup.' + name)
          }

          price = Number(self.datas.price);
          diskaun = Number(self.datas.diskaun);
          price_before_discount = Number(self.datas.price_before_discount);
        } else {
          //价格、折扣、重量、库存只能为数字
          if (isNaN(eval('self.datas.customize_tier_variations[ix].' + name)) || eval(
              'self.datas.customize_tier_variations[ix].' + name) == " ") {
            eval('self.datas.customize_tier_variations[ix].' + name +
              '= self.datas_Backup.customize_tier_variations[ix].' + name)
          }

          price = Number(self.datas.customize_tier_variations[ix].price);
          price_before_discount = Number(self.datas.customize_tier_variations[ix].price_before_discount);
          diskaun = Number(self.datas.customize_tier_variations[ix].diskaun);
        }
        if (te) {
          _price = diskaun * 0.1 * price_before_discount;
          if (_price > 100) {
            _price = _price.toFixed(0);
          } else {
            _price = _price.toFixed(2);
          }
        } else {
          if (price && price_before_discount) {
            _diskaun = ((price / price_before_discount) * 10).toFixed(1);
          }
        }
        if (origin == 1) {
          if (_price) {
            self.datas.price = _price;
          }
          if (_diskaun) {
            self.datas.diskaun = _diskaun;
          }
        } else {
          if (_price) {
            self.datas.customize_tier_variations[ix].price = _price;
          }
          if (_diskaun) {
            self.datas.customize_tier_variations[ix].diskaun = _diskaun;
          }
        }

        self.$forceUpdate();
      },
      RecoverPrice() {
        let te = self.datas.is_tier_variations;
        if (te) {
          self.datas.customize_tier_variations = JSON.parse(JSON.stringify(self.datas.models));
        } else {
          self.datas.price = JSON.parse(JSON.stringify(self.datas_Backup.price));
          self.datas.price_before_discount = JSON.parse(JSON.stringify(self.datas_Backup.price_before_discount));
        }
        self.$forceUpdate();
      },
      DeleteDiscount() {
        self.datas.discount_info = null;
        self.$forceUpdate();
      },
      onEnd(evt) {
        let ix = evt.from.dataset.ix;
        let imgs = self.datas.tier_variations[ix].images;
        if(ix == 0 && imgs.length > 0){
          let img = imgs[evt.oldIndex];
          imgs.splice(evt.oldIndex,1);
          imgs.splice(evt.newIndex,0,img);
        }
        self.CreateSkuArr(self.datas);
      },
      OperateImg(te,sku) {
        if (te == 1) { //保留选中
          let imgs = [];
          if(sku){  //SKU
            for (let i in self.datas.tier_variations[0].images) {
              if (!self.datas.tier_variations[0].images[i].isActive) {
                self.datas.tier_variations[0].images[i].url = null;
              }
            }
          }else{  //产品主图
            for (let i in self.datas.images) {
              if (self.datas.images[i].isActive) {
                imgs.push(self.datas.images[i])
              }
            }
            self.datas.images = imgs;
          }
        } else if (te == 2) { //删除选中
          if(sku){  //SKU
            let imgs = self.datas.tier_variations[0].images;
            for (let i = imgs.length - 1; i >= 0; i--) {
              if (imgs[i].isActive) {
                imgs[i].url = null;
                imgs[i].isActive = false;
              }
            }
            self.allSkuImg = false;
          }else{
            let imgs = JSON.parse(JSON.stringify(self.datas.images))
            for (let i = imgs.length - 1; i >= 0; i--) {
              if (imgs[i].isActive) {
                imgs.splice(i, 1);
              }
            }
            self.allImg = false;
            self.datas.images = imgs;
          }
          self.$forceUpdate();
        }
      },
      SelectLanguage(etype,id) {
        if (id) {
          let imgs = [];
          if(self.datas.etype == "pro"){
            for (let i in self.datas.images) {
              if (self.datas.images[i].isActive) {
                imgs.push(self.datas.images[i]);
              }
            }
          }else{
            for (let i in self.datas.tier_variations[0].images) {
              if (self.datas.tier_variations[0].images[i].isActive) {
                imgs.push(self.datas.tier_variations[0].images[i]);
              }
            }
          }

          if (imgs.length > 0) {
            self.TranslationImg(etype,id);
          } else {
            self.ToastFun(1, '请先选择图片！'); //弹窗提醒
          }
        }
      },
      TranslationImg(etype,lang) {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('lang', lang);

        if(self.datas.etype == "pro"){
          param.append('images', JSON.stringify(self.datas.images));
        }else{
          param.append('images', JSON.stringify(self.datas.tier_variations[0].images));
        }

        let _url = "/translation_img/";
        if(etype == 0){
          _url = "/translation_img_free/"
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + _url,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if(self.datas.etype == "pro"){
              self.datas.images = datas;
            }else{
              self.datas.tier_variations[0].images = datas;
            }
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      mouseLeave() {
        self.isClick = false;
      },
      NavClick(ix) {
        for (let item in self.navlist) {
          self.navlist[item].NavActive = false;
        }
        self.navlist[ix].NavActive = true;
        self.$forceUpdate();
      },
      Source() {
        window.open(self.datas.origin);
      },
      RestorePicture(etype) {
        if(etype == 'pro'){
          self.datas.images = JSON.parse(JSON.stringify(self.datas.imagesBackup));
        }else{
          self.datas.tier_variations[0].images = JSON.parse(JSON.stringify(self.datas_Backup.tier_variations[0].images));
        }
      },
      WaterPrint(id) {
        let imgs = [];
        if(self.datas.etype == 'pro'){
          for (let i in self.datas.images) {
            if (self.datas.images[i].isActive) {
              imgs.push(self.datas.images[i]);
            }
          }
        }else{
          for (let i in self.datas.tier_variations[0].images) {
            if (self.datas.tier_variations[0].images[i].isActive) {
              imgs.push(self.datas.tier_variations[0].images[i]);
            }
          }
        }
        if (imgs.length > 0) {
          self.loading = true;
          let param = new URLSearchParams();
          param.append('id', id);
          if(self.datas.etype == 'pro'){
            param.append('images', JSON.stringify(self.datas.images));
          }else{
            param.append('images', JSON.stringify(self.datas.tier_variations[0].images));
          }
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/water_print/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.isClick = false;
              $(".WatermarkMenu").hide();
              self.datas.WatermarkImages = datas;
              self.RenderWatermarkPicList();
              layer.msg("水印处理完成！");
            }, false, true);
          }).catch(function(error) {
            self.loading = false;
            layer.msg("水印设置失败，请重试！");
          })
        } else {
          self.ToastFun(1, '请先选择图片！'); //弹窗提醒
        }

      },
      ShowWaterPrint(etype) {
        let imgs = [];
        self.datas.etype = etype;
        if(etype == "pro"){
          for (let i in self.datas.images) {
            if (self.datas.images[i].isActive) {
              imgs.push(self.datas.images[i])
            }
          }
        }else{
          for (let i in self.datas.tier_variations[0].images) {
            if (self.datas.tier_variations[0].images[i].isActive) {
              imgs.push(self.datas.tier_variations[0].images[i])
            }
          }
        }
        if (imgs.length <= 0) {
          layer.msg("请选择图片！");
          return;
        }

        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "图片水印",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: WaterPrintHtml,
          success: function() {
            if(etype == "pro"){
              self.datas.WatermarkImages = JSON.parse(JSON.stringify(self.datas.images));
            }else{
              self.datas.WatermarkImages = JSON.parse(JSON.stringify(self.datas.tier_variations[0].images));
            }
            self.RenderWatermarkPicList();

            form.on('submit(SetWatermark)', function(data) {
              if (!WatermarkList || WatermarkList.length <= 0) {
                layer.msg("水印模板为空，请先添加模板！");
                return;
              }

              let xml = ""
              for (let i in WatermarkList) {
                xml += '<li class="NoSelect" data-id="' + WatermarkList[i].id + '">' + WatermarkList[
                    i].name +
                  '</li>'
              }
              if ($(".WatermarkMenu").is(":visible")) {
                $(".WatermarkMenu").hide();
              } else {
                $(".WatermarkMenu").html(xml).show();
              }

              //点击水印模板
              $(".WatermarkMenu li").click(function() {
                let id = $(this).attr("data-id");
                self.WaterPrint(id);
              })

            });
            form.on('submit(AddWaterPrint)', function(data) {
              self.AddWatermarkTemplate();
            });
            form.on('submit(ClearWaterPrint)', function(data) {
              self.datas.WatermarkImages = JSON.parse(JSON.stringify(self.datas.images));
              self.RenderWatermarkPicList();
              layer.msg("清除水印完成！");
            });
            form.on('submit(WaterPrintList)', function(data) {
              self.WatermarkListModule();
            });
            self.WatermarkList(); //加载水印列表

            form.render();
          },
          yes: function(index, layero) {
            if(self.datas.etype == "pro"){
              self.datas.images = JSON.parse(JSON.stringify(self.datas.WatermarkImages));
            }else{
              self.datas.tier_variations[0].images = JSON.parse(JSON.stringify(self.datas.WatermarkImages));
            }
            layer.close(xmlModule);
            self.$forceUpdate();
          }
        });
      },
      RenderWatermarkPicList() {
        var xml = "";
        for (let i in self.datas.WatermarkImages) {
          if (self.datas.WatermarkImages[i].isActive) {
            xml += "<li>"
            xml += '<p class="col-img layui-form WatermarkListImage" data-img="' + self.datas.WatermarkImages[i]
              .url +
              '" style="background-image: url(' + self.datas.WatermarkImages[i].url + ')"></p>'
            xml += "</li>"
          }
        }
        $(".module-img-list").html(xml);
        $(".WatermarkListImage").click(function() {
          window.open($(this).attr("data-img"));
        });
      },
      AddWatermarkTemplate(id) {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlTwoModule = layer.open({
          type: 1,
          offset: '100px',
          title: "添加水印模板",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: AddWaterPrintHtml,
          success: function() {
            var imgs = [],
              sliderDVal = 1;

            //编辑
            if (id) {
              for (let i in WatermarkList) {
                if (WatermarkList[i].id == id) {
                  sliderDVal = 10 - WatermarkList[i].transparency * 10;
                  $("#WaterPType input[name=WaterPType][value=" + WatermarkList[i].water_type + "]").prop(
                    "checked", "true");
                  $("#WaterPLog input[name=WaterPLog][value=" + WatermarkList[i].position + "]").prop(
                    "checked",
                    "true");
                  $("#WaterPName").val(WatermarkList[i].name);
                  if (WatermarkList[i].water_type == 1) {
                    $("#WaterPImg").attr("src", WatermarkList[i].water_img);
                    $(".WaterPImgBox,.WaterPImg").show();
                    $(".WaterPTxt,.WaterPfont").hide();
                  } else {
                    $("#WaterPTxt").val(WatermarkList[i].text);
                    $("#WaterPSize").val(WatermarkList[i].text_size);
                    $(".WaterPImgBox,.WaterPImg").hide();
                    $(".WaterPTxt,.WaterPfont").show();
                    $(".WaterPfont").text(WatermarkList[i].text);
                    $("#WaterPBox").css({
                      'fontSize': WatermarkList[i].text_size + 'px'
                    });
                  }
                  $("#WaterPX").val(WatermarkList[i].position_x);
                  $("#WaterPY").val(WatermarkList[i].position_y);
                }
              }
            } else {
              self.WatermarkID = null;
            }

            slider.render({
              elem: '#SlideOpacity',
              step: 1, //步长
              min: 1,
              max: 10,
              value: sliderDVal,
              change: function(val) {
                sliderVal = val;
                if (!isSlider) {
                  isSlider = true;
                  setTimeout(function() {
                    self.WaterPLocation();
                    isSlider = false;
                  }, 300)
                }
              }
            });

            //水印类型
            form.on('radio(WaterPType)', function(data) {
              if (data.value == 1) {
                $(".WaterPImgBox,.WaterPImg").show();
                $(".WaterPTxt,.WaterPfont").hide();
              } else if (data.value == 2) {
                $(".WaterPImgBox,.WaterPImg").hide();
                $(".WaterPTxt,.WaterPfont").show();
              }
              form.render();
            });

            $("#WaterPX").change(function() {
              self.WaterPLocation();
            })
            $("#WaterPY").change(function() {
              self.WaterPLocation();
            })
            self.WaterPLocation();
            $("#WaterPTxt").change(function() {
              $("#WaterPfont").text($(this).val());
              self.WaterPLocation();
            })
            $("#WaterPSize").change(function() {
              $("#WaterPfont").css({
                'fontSize': $(this).val() + 'px'
              });
              self.WaterPLocation();
            })
            form.on('radio(WaterPLog)', function(data) {
              self.WaterPLocation();
            });

            form.render();
          },
          yes: function(index, layero) {
            let WaterPType = $('#WaterPType input[name="WaterPType"]:checked').val();
            let WaterPName = $("#WaterPName").val();
            let WaterPImg = $("#WaterPImg").attr("src");
            let WaterPTxt = $("#WaterPTxt").val();
            let WaterPSize = $("#WaterPSize").val();
            let WaterPLog = $('#WaterPLog input[name="WaterPLog"]:checked').val()
            let WaterPX = $("#WaterPX").val();
            let WaterPY = $("#WaterPY").val();
            let op = (1 - sliderVal * 0.1).toFixed(2);

            let param = new URLSearchParams();
            if (self.WatermarkID) {
              param.append('id', self.WatermarkID);
            }
            if (!WaterPName) {
              layer.msg("模板名称不能为空！");
              return;
            }
            if (WaterPType == 1) { //图片
              if (!WaterPImg) {
                layer.msg("图片不能为空！");
                return;
              }
              param.append('water_img', WaterPImg);
            } else { //文字
              if (!WaterPTxt) {
                layer.msg("文字不能为空！");
                return;
              }
              if (!WaterPSize) {
                layer.msg("文字大小不能为空！");
                return;
              }
              param.append('text', WaterPTxt);
              param.append('text_size', WaterPSize);
            }

            self.loading = true;
            param.append('water_type', WaterPType);
            param.append('name', WaterPName);
            param.append('position', WaterPLog);
            param.append('position_x', WaterPX);
            param.append('position_y', WaterPY);
            param.append('transparency', op);

            axios({
              method: 'post',
              url: self.GetServerUrl() + "/store_water/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {
              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.WatermarkList();
                layer.msg("水印模板添加成功！");
                layer.close(xmlTwoModule);
              }, false, true);
            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })
          }
        });
      },
      WaterPLocation() {
        let boxw = $(".WaterPBox").width() / 2;
        let boxh = $(".WaterPBox").height() / 2;
        let xp = $("#WaterPX").val();
        let yp = $("#WaterPY").val();
        let log = $('#WaterPLog input[name="WaterPLog"]:checked').val()
        let op = 1 - sliderVal * 0.1;
        let cssdis = {};
        $("#OffsetBox").show();
        if (log == 1 || log == 4 || log == 7) {
          $("#WaterPXBox").show();
          $("#WaterPYBox").show();
          if (log == 1) {
            cssdis = {
              left: xp + 'px',
              top: yp + 'px'
            }
          } else if (log == 4) {
            $("#WaterPYBox").hide();
            cssdis = {
              left: xp + 'px',
              top: 'calc(50% - ' + boxh + 'px)'
            }
          } else if (log == 7) {
            cssdis = {
              left: xp + 'px',
              bottom: yp + 'px'
            }
          }
        } else if (log == 2 || log == 5 || log == 8) {
          $("#WaterPXBox").hide();
          $("#WaterPYBox").show();
          if (log == 2) {
            cssdis = {
              left: 'calc(50% - ' + boxw + 'px)',
              top: yp + 'px'
            }
          } else if (log == 5) {
            $("#WaterPYBox,#OffsetBox").hide();
            cssdis = {
              left: 'calc(50% - ' + boxw + 'px)',
              top: 'calc(50% - ' + boxh + 'px)'
            }
          } else if (log == 8) {
            cssdis = {
              left: 'calc(50% - ' + boxw + 'px)',
              bottom: yp + 'px'
            }
          }
        } else if (log == 3 || log == 6 || log == 9) {
          $("#WaterPXBox").show();
          $("#WaterPYBox").show();
          if (log == 3) {
            cssdis = {
              right: xp + 'px',
              top: yp + 'px'
            }
          } else if (log == 6) {
            $("#WaterPYBox").hide();
            cssdis = {
              right: xp + 'px',
              top: 'calc(50% - ' + boxh + 'px)'
            }
          } else if (log == 9) {
            cssdis = {
              right: xp + 'px',
              bottom: yp + 'px'
            }
          }
        }
        cssdis.opacity = op;
        $(".WaterPBox").removeAttr("style").css(cssdis);
      },
      WatermarkList(te) {
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_water_list/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          self.loading = false;
          var json = res.data;
          if (json.code == 200) {
            let list = json.datas.list;
            WatermarkList = list;
            $(".WatermarkMenu").hide();
          } else {
            WatermarkList = null;
          }
          if (te) {
            self.RenderWatermarkList();
          }

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      WatermarkListModule() {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlThreeModule = layer.open({
          type: 1,
          offset: '100px',
          title: "管理水印模板",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['刷新列表', '取消'],
          content: WatermarkListHtml,
          success: function() {
            self.RenderWatermarkList();
            form.on('submit(EditWatermark)', function(data) {
              self.WatermarkID = data.elem.dataset.id;
              self.AddWatermarkTemplate(data.elem.dataset.id);
            });
            form.on('submit(DeleteWatermark)', function(data) {
              self.DeleteWatermark(data.elem.dataset.id);
            });

            form.render();
          },
          yes: function(index, layero) {
            self.WatermarkList();
          }
        });
      },
      RenderWatermarkList() {
        var xml = ""
        for (let i in WatermarkList) {
          xml += "<tr>"
          xml += "<td>" + WatermarkList[i].name + "</td>"
          xml += "<td>"
          if (WatermarkList[i].water_type == 1) {
            xml += '<img src="' + WatermarkList[i].water_img + '" />'
          } else {
            xml += '<div style="font-size:' + WatermarkList[i].text_size + 'px">' + WatermarkList[i].text +
              '</div>'
          }
          xml += "</td>"
          xml += "<td>" + WatermarkList[i].created_at + "</td>"
          xml += '<td class="btn-arr" style="width:140px">'
          xml += '<button type="button" class="layui-btn" lay-submit data-id="' + WatermarkList[i].id +
            '" lay-filter="EditWatermark">编辑</button>'
          xml += '<button type="button" class="layui-btn layui-btn-danger" lay-submit data-id="' +
            WatermarkList[i].id +
            '" lay-filter="DeleteWatermark">删除</button>'
          xml += "</td>"
          xml += "</tr>"
        }
        $("#WatermarkList").html(xml);
        if (!WatermarkList) {
          $(".WatermarkNull").show();
        }
      },
      DeleteWatermark(id) {
        let param = new URLSearchParams();
        param.append('id', id);

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/del_water/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.WatermarkList(true);
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      WebPicture(etype, ix) {
        let picbox = layer.prompt({
          title: '添加网络地址',
          formType: 2,
          area: ['600px', '200px']
        }, function(pass, index) {

          if (etype == "pro") {
            var img = new Image();
            img.src = pass;
            img.onload = function() {
              self.datas.images.push({
                isActive: false,
                url: pass,
                size: img.width + "x" + img.height
              });
            };
          } else {
            self.datas.tier_variations[0].images[ix].url = pass;
            self.$forceUpdate();
          }
          layer.close(picbox);
        });
      },
      PictureSelection(etype, title, ix) {
        var w, h;
        self.etype = etype;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        var PictureSpace = layer.open({
          type: 1,
          offset: '100px',
          title: title,
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: PictureSelectionHtml,
          skin: 'picture-space-module',
          success: function() {
            if (title == "产品图片") {
              self.ShowSpaceList(self.datas.images)
              $(".PictureSpaceCount").text(self.datas.images.length);
            } else {
              self.GetSpacePicture(self.SpacePage);
            }
          },
          yes: function(index, layero) {
            $(".space-box").each(function() {
              let isActive = $(this).attr("data-active");
              if (JSON.parse(isActive)) {
                let img = $(this).find(".col-img").attr("data-img");
                let size = $(this).find(".col-img").attr("data-size");
                if (etype == "pro") {
                  self.datas.images.push({
                    isActive: false,
                    url: img,
                    size: size
                  });
                } else {
                  self.datas.tier_variations[0].images[ix].url = img;
                }
              }
            })
            self.Spaceimgs = [];
            self.$forceUpdate();
            layer.close(PictureSpace);
          },
          btn2: function() {
            self.Spaceimgs = [];
          }
        });
      },
      GetSpacePicture(page) {
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_space/?page=" + page,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              let list = datas.list;
              $(".PictureSpaceCount").text(datas.page.count);
              var x = 0,
                imgobj = {};
              for (var img in list) {
                list[img].size = null;
                if (!imgobj.hasOwnProperty(img)) {
                  imgobj[img] = []
                }
                imgobj[img] = new Image()
                imgobj[img].src = list[img].url;
                imgobj[img].onload = function() {
                  x++;
                  if (list.length == x) {
                    for (let y in list) {
                      list[y].size = imgobj[y].width + "x" + imgobj[y].height;
                    }
                    self.ShowSpaceList(list);
                  }
                };
              }
              self.ShowSpaceList(list);
              //分页
              $(".picture-space-module").find(".layui-layer-btn").css("position", "relative").append(
                '<div id="SpacePage"></div>');
              self.ShowSpacePage(self, laypage, "GetSpacePicture", datas.page);
            }
          });

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowSpaceList(imgs) {
        var xml = "";
        for (let i in imgs) {
          xml += "<li class='space-box' data-active='false'>"
          xml += '<p class="col-img layui-form" data-img="' + imgs[i].url +
            '" data-size="' + imgs[i].size + '" style="background-image: url(' + imgs[i].url + ')">'
          xml +=
            '<i class="col-select"><input class="col-select-checkbox" type="checkbox" lay-skin="primary"></i>'
          xml += '<a class="space-select-box NoSelect" data-ix="' + i + '"></a>'
          if (imgs[i].size) {
            xml += '<a class="col-img-size" style="bottom:0">' + imgs[i].size + '</a>'
          }
          xml += '</p>'
          xml += '</li>'
        }
        $(".module-img-list").html(xml);
        form.render();
      },
      TitleCheck(etype) {
        if(etype == 1){
          let len = self.datas.name.length;
          let max, min;
          if (self.shop && self.shop.country == "TW") {
            min = 10;
            max = 60;
          } else {
            min = 20;
            max = 255;
          }

          self.titleHint = false;
          if (len < min) {
            self.titleHintTxt = "商品标题过短，请输入至少 " + min + " 个字！"
            self.titleHint = true;
          } else if (len > max) {
            self.titleHintTxt = "商品标题过长，请输入最多 " + max + " 个字！"
            self.titleHint = true;
          }
          let name = self.datas.name;
          if (name.substring(0, 1) == " " || name.substring(name.length - 1, name.length) == " ") {
            self.titleHint = true;
            self.titleHintTxt = "此字段的开头或结尾不允许使用白色空格！"
          }
        }else{
          let len = self.datas.description.length;
          let max, min;
          if (self.shop && self.shop.country == "TW") {
            min = 3;
            max = 3000;
          } else {
            min = 1;
            max = 10000;
          }

          self.desHint = false;
          if (len < min) {
            self.desHintTxt = "商品描述过短，请输入至少 " + min + " 个字！"
            self.desHint = true;
          } else if (len > max) {
            self.desHintTxt = "商品描述过长，请输入最多 " + max + " 个字！"
            self.desHint = true;
          }
        }
      },
      AutoSku(ix) {
        for (let i in self.datas.tier_variations[ix].options) {
          self.EditFun(ix, i, "#" + (Number(i) + 1));
        }
      },
      Reduction(ix) {
        self.datas.tier_variations[ix] = JSON.parse(JSON.stringify(self.datas_Backup.tier_variations[ix]));
        self.CreateSkuArr(self.datas, true); //更新SKU表
      },
      UnitConversion (ix) {
        let list = self.datas.tier_variations[ix].options;
        let size_list = self.SizeList();
        let sku_name,isConversion = false;
        for(let i in list){
          let size_arr = list[i].replace(/[^0-9]/ig," ");
          let arr = size_arr.split(" ");

          //判断是否有体重需要转换
          if(list[i].search("斤") > 0 || isConversion){
            isConversion = true;
          }else{
            continue;
          }

          //尺码匹配
          let size_name;
          for(let x in size_list){
            let patt = new RegExp(size_list[x],'i');
            let return_obj = patt.exec(list[i]);
            if(return_obj && return_obj.length > 0){
              size_name = return_obj[0];
            }
          }

          for (let x = arr.length - 1; x >= 0; x--) {
            if (!arr[x] || arr[x].length <= 1) {
              arr.splice(x, 1);
            }else{
              arr[x] /= 2;
            }
          }

          //判断是否有体重
          if(arr.length <= 0){
            continue;
          }

          //如果没有匹配尺码，自动填充
          if(!size_name){
            size_name = size_list[i];
          }
          if(arr.length >= 2){
            sku_name = size_name +": "+ arr[0] +'-'+ arr[1] + 'kg'
          }else{
            sku_name = size_name +": "+ arr[0] + 'kg以内'
          }

          self.EditFun(ix, i, sku_name);
        }
      },
      SetUsedClassify () {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('shop_id', self.shop.id);
        param.append('data', JSON.stringify(self.datas.categories));

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/category_use_store/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            layer.msg("设置成功！");
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowUsedClassify () {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "常用分类",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          content: UsedClassify,
          success: function() {
            self.LoadUsedClassify(1);

            form.on('submit(SelectUsedClassify)', function(data) {
              let categories = self.UsedClassify[data.elem.dataset.ix].data;
              self.datas.categories = categories;
              self.datas.isSpecial = categories[categories.length - 1].category_type; //货物类型
              self.get_attributes(categories[categories.length - 1].catid); //加载商品属性
              layer.close(xmlModule);
            });

            form.on('submit(DeleteUsedClassify)', function(data) {
              self.DeleteUsedClassify(data.elem.dataset.id);
            });

          },
          yes: function(index, layero) {

          }
        });
      },
      LoadUsedClassify (page) {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('shop_id', self.shop.id);
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/category_use/?page=" + page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          self.loading = false;
          var json = res.data;
          if (json.code == 200) {
            self.UsedClassify = json.datas;
          }
          self.ShowUsedClassifyXml(json.datas)
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowUsedClassifyXml(datas) {
        var xml = ""
        console.log(datas)
        for (let i in datas) {
          datas[i].data = JSON.parse(datas[i].data);
          xml += "<tr>"
          xml += "<td>"
          xml += "<div class='col-classify'>"
          for(let x in datas[i].data){
            xml += "<a>"
            if(datas[i].data[x].display_name_zh){
              xml += '<i>'+datas[i].data[x].display_name_zh+'「'+datas[i].data[x].display_name+'」</i>'
            }else{
              xml += '<i>'+datas[i].data[x].display_name+'</i>'
            }
            if(x != (datas[i].data.length-1)){
              xml += "<i>> </i>"
            }
            xml += "</a>"
          }
          xml += "</div>"
          xml += "</td>"
          xml += "<td>" + datas[i].created_at + "</td>"
          xml += '<td class="btn-arr" style="width:140px">'
          xml += '<button type="button" class="layui-btn" lay-submit data-ix="'+i+'" lay-filter="SelectUsedClassify">选择</button>'
          xml += '<button type="button" class="layui-btn layui-btn-danger" lay-submit data-id="'+datas[i].id+'" lay-filter="DeleteUsedClassify">删除</button>'
          xml += "</td>"
          xml += "</tr>"
        }
        $("#UsedClassify").html(xml);
        if (!datas) {
          $(".WatermarkNull").show();
        }
      },
      DeleteUsedClassify(id) {
        let param = new URLSearchParams();
        param.append('id', id);

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/category_use_del/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.LoadUsedClassify(true);
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      titleUpper () {
        self.datas.name = self.UppercaseConversion(self.datas.name);
      },
      TriggerPulldown (etype) {
        self.datas.etype = etype;
      },
      PositionJump (id,num) {
        let count = 0;
        if(num){
          count = num;
        }
        let top = $("#"+id)[0].offsetParent.offsetTop;
        $('.col-box').animate({
          scrollTop: (top+count) + 'px'
        }, 200);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .description-textarea{
    resize:vertical;
    padding:15px;
    overscroll-behavior: auto contain;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }

  .description-hint{
    position:relative;
    float:right;
    width:auto;
    border:0;
    top:0;bottom:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Edit.vue